export const api = {
  checkCreditCode: '/apps/company/checkCreditCode', // 检查是否有重复信用代码
  calcEnterpriseScale: '/apps/company/calcEnterpriseScale', // 计算企业规模
  getVillageByTown: '/apps/common/getVillageByTown', // 获取村列表
  getProvinceList: '/apps/common/getProvinceList', // 获取省份
  getSubCityList: '/apps/common/getSubCityList', // 获取市
  getSubConutyList: '/apps/common/getSubConutyList', // 获取县
  getSubTownList: '/apps/common/getSubTownList', // 获取乡镇
  getAreaAndTown: '/apps/dictionary/getAreaAndTown', // 获取账号区域和乡镇
  resetPassword: '/apps/company/resetPassword', // 重置企业密码
  deleteCompany: '/apps/company/delete', // 关闭账号
  getCompanyList: '/apps/company/getList', // 查询企业列表
  getNoticeCompanyList: '/apps/company/getNoticeCompanyList', // 通知公告-查询企业列表
  getCompaniesList: '/apps/company/getCompaniesList', // 查询企业列表
  getNewCompanyList: '/apps/company/getCompanyList', // 查询企业列表
  companyDeletePasswordCache: '/apps/company/deletePasswordCache', // 一企一档-解除锁定
  getRiskCompanyList: '/apps/company/getRiskCompanyList', // 大屏企业清单
  getStandardList: '/apps/company/getStandardList', // 查询评审标准化
  getStandardListByselfList: '/apps/company/getStandardListByself', // 查询自评标准化
  getDepartmentListByAdmin: '/apps/department/getList', // 查询部门列表
  getDepartmentInfo: '/apps/department/getInfo', // 查询部门信息
  deleteDepartmentByAdmin: '/apps/department/delete', // 删除部门信息
  departmentAccountDeletePasswordCache: '/apps/department/deletePasswordCache', // 部门账号配置-解除锁定
  getDepartmentList: '/apps/organization/getOrganizationTree', // 获取部门列表
  addOrUpdateDepartment: '/apps/organization/addOrUpdateOrganization',
  deleteDepartment: '/apps/organization/deleteOrganization',
  getTownList: '/apps/town/getList', // 查询乡镇列表
  getTownInfo: '/apps/town/getInfo', // 查询乡镇信息
  addOrUpdateTownInfo: '/apps/town/addOrUpdate', // 乡镇信息增或改
  deleteTown: '/apps/town/delete', // 删除乡镇信息
  townDeletePasswordCache: '/apps/town/deletePasswordCache', // 街镇账号配置-解除锁定
  getVillageList: '/apps/village/getList', // 查询村列表
  deleteVillage: '/apps/village/delete', // 删除乡镇信息
  villageDeletePasswordCache: '/apps/village/deletePasswordCache', // 街镇账号配置-解除锁定
  addOrUpdateVillageInfo: '/apps/village/addOrUpdate', // 乡镇信息增或改
  departmentAddOrUpdate: '/apps/department/addOrUpdate', // 部门基本信息增或改
  getDepartmentSpecialInfo: '/apps/department/getDepartmentSpecialInfo', // 查询部门特殊信息
  updateDepartmentSpecialInfo: '/apps/department/updateDepartmentSpecialInfo', // 部门特殊信息修改
  getBaseDepartmentTypeList: '/apps/dictionary/getBaseDepartmentTypeList', // 获取部门列表
  addOrUpdateBaseDepartmentType:
    '/apps/dictionary/addOrUpdateBaseDepartmentType', // 增改部门
  deleteBaseDepartmentType: '/apps/dictionary/deleteBaseDepartmentType', // 删除部门
  getCurrentChangeBatchList: '/apps/change/getCurrentChangeBatchList', // 获取变更列表
  applyConfirm: '/apps/change/applyConfirm', // 通过审核
  applyRefuse: '/apps/change/applyRefuse', // 拒绝审核
  getDepartmentStaffList: '/apps/department/getDepartmentStaffList', // 部门人员列表(查)
  addOrUpdateDepartmentStaff: '/apps/department/addOrUpdateDepartmentStaff', // 部门人员列表(增,改)
  deleteDepartmentStaff: '/apps/department/deleteDepartmentStaff', // 部门人员列表(删除)
  getTownStaffList: '/apps/town/getTownStaffList', // 乡镇人员列表(查)
  addOrUpdateTownStaff: '/apps/town/addOrUpdateTownStaff', // 乡镇人员列表(增,改)
  deleteTownStaff: '/apps/town/deleteTownStaff', // 乡镇人员列表(删除)
  getDepartmentExerciseList: '/apps/department/getDepartmentExerciseList', // 部门演练列表(查)
  addOrUpdateDepartmentExercise:
    '/apps/department/addOrUpdateDepartmentExercise', // 部门演练列表(增,改)
  deleteDepartmentExercise: '/apps/department/deleteDepartmentExercise', // 部门演练列表(删除)
  getDepartmentAccidentList: '/apps/department/getDepartmentAccidentList', // 部门近五年事故(查)
  addOrUpdateDepartmentAccident:
    '/apps/department/addOrUpdateDepartmentAccident', // 部门近五年事故(增,改)
  deleteDepartmentAccident: '/apps/department/deleteDepartmentAccident', // 部门近五年事故(删除)
  getDepartmentDeathList: '/apps/department/getDepartmentDeathList', // 部门近五年死亡情况(查)
  addOrUpdateDepartmentDeath: '/apps/department/addOrUpdateDepartmentDeath', // 部门近五年死亡情况(增,改)
  deleteDepartmentDeath: '/apps/department/deleteDepartmentDeath', // 部门近五年死亡情况(删除)
  getTownAccidentList: '/apps/town/getTownAccidentList', // 乡镇近五年事故(查)
  addOrUpdateTownAccident: '/apps/town/addOrUpdateTownAccident', // 乡镇近五年事故(增,改)
  deleteTownAccident: '/apps/town/deleteTownAccident', // 乡镇近五年事故(删除)
  getTownDeathList: '/apps/town/getTownDeathList', // 乡镇近五年死亡情况(查)
  addOrUpdateTownDeath: '/apps/town/addOrUpdateTownDeath', // 乡镇近五年死亡情况(增,改)
  deleteTownDeath: '/apps/town/deleteTownDeath', // 乡镇近五年死亡情况(删除)
  // -------------------
  getCurrentChangeBatch: '/apps/change/getCurrentChangeBatch', // 获取当前次的变更id
  submitChangeBatch: '/apps/change/submitChangeBatch', // 提交变更id
  checkCompanyUnitAssessment: '/apps/unit/checkCompanyUnitAssessment', // 检测风险单元是否都完成参数填写
  register: '/apps/company/register', // 企业注册
  dictionary: '/apps/dictionary/getAllDictionary', // 获取配置
  companyGetInfo: '/apps/company/getInfo', // 获取企业基本信息
  updateBaseInfo: '/apps/company/updateBaseInfo', // 修改企业信息
  addOrUpdateBaseInfo: '/apps/company/addOrUpdate', // 修改企业信息
  getSpecialOperationList: '/apps/company/getSpecialOperationList', // 特种作业(查)
  addOrUpdateSpecialOperation: '/apps/company/addOrUpdateSpecialOperation', // 特种作业(增,改)
  deleteSpecialOperation: '/apps/company/deleteSpecialOperation', // 特种作业(删除)
  getSafetyAccidentsList: '/apps/company/getSafetyAccidentsList', // 伤亡事故(查)
  addOrUpdateSafetyAccidents: '/apps/company/addOrUpdateSafetyAccidents', // 伤亡事故(增,改)
  deleteSafetyAccidents: '/apps/company/deleteSafetyAccidents', // 伤亡事故(删除)
  getTeachingCarsList: '/apps/company/getTeachingCarsList', // 教学车辆信息(查)
  addOrUpdateTeachingCars: '/apps/company/addOrUpdateTeachingCars', // 教学车辆信息(增,改)
  deleteTeachingCars: '/apps/company/deleteTeachingCars', // 教学车辆信息(删除)
  getSurroundingWeakTargetList: '/apps/company/getSurroundingWeakTargetList', // 周边脆弱性目标(查)
  addOrUpdateSurroundingWeakTarget:
    '/apps/company/addOrUpdateSurroundingWeakTarget', // 周边脆弱性目标(增,改)
  deleteSurroundingWeakTarget: '/apps/company/deleteSurroundingWeakTarget', // 周边脆弱性目标(删除)
  getRiskUnitList: '/apps/unit/getRiskUnitList', // 风险单元
  addOrUpdateRiskUnit: '/apps/unit/addOrUpdateRiskUnit', // 风险单元(增,改)
  deleteRiskUnit: '/apps/unit/deleteRiskUnit', // 风险单元(删除)
  getRiskInventoryList: '/apps/unit/getRiskInventoryList', // 单元风险清单
  addOrUpdateRiskInventory: '/apps/unit/addOrUpdateRiskInventory', // 单元风险清单(增,改)
  deleteRiskInventory: '/apps/unit/deleteRiskInventory', // 单元风险清单(删除)
  getHiddenDangerInventoryList: '/apps/unit/getHiddenDangerInventoryList', // 单元隐患清单
  addOrUpdateHiddenDangerInventory:
    '/apps/unit/addOrUpdateHiddenDangerInventory', // 单元隐患清单(增,改)
  deleteHiddenDangerInventory: '/apps/unit/deleteHiddenDangerInventory', // 单元隐患清单(删除)
  getMajorHazardSourceInventoryList:
    '/apps/unit/getMajorHazardSourceInventoryList', // 单元重大危险源清单
  addOrUpdateMajorHazardSourceInventory:
    '/apps/unit/addOrUpdateMajorHazardSourceInventory', // 单元重大危险源清单(增,改)
  deleteMajorHazardSourceInventory:
    '/apps/unit/deleteMajorHazardSourceInventory', // 单元重大危险源清单(删除)
  getRiskGraphList: '/apps/unit/getRiskGraphList', // 单元风险分布图
  addOrUpdateRiskGraph: '/apps/unit/addOrUpdateRiskGraph', // 单元风险分布图(增,改)
  getAssessment: '/apps/unit/getAssessment', // 风险评估数据
  updateAssessment: '/apps/unit/updateAssessment', // 风险评估数据(改)
  getFocusChemicalProcessList: '/apps/industrial/getFocusChemicalProcessList', // 重点监管化工工艺
  addOrUpdateFocusChemicalProcess:
    '/apps/industrial/addOrUpdateFocusChemicalProcess', // 重点监管化工工艺(增,改)
  deleteFocusChemicalProcess: '/apps/industrial/deleteFocusChemicalProcess', // 重点监管化工工艺(删除)
  getBoomDustList: '/apps/industrial/getBoomDustList', // 涉爆粉尘
  addOrUpdateBoomDust: '/apps/industrial/addOrUpdateBoomDust', // 涉爆粉尘(增,改)
  deleteBoomDust: '/apps/industrial/deleteBoomDust', // 涉爆粉尘(删除)
  getExplosiveList: '/apps/industrial/getExplosiveList', // 单元内民用爆炸品统计
  addOrUpdateExplosive: '/apps/industrial/addOrUpdateExplosive', // 单元内民用爆炸品统计(增,改)
  deleteExplosive: '/apps/industrial/deleteExplosive', // 单元内民用爆炸品统计(删除)
  getDangerousChemicalList: '/apps/industrial/getDangerousChemicalList', // 单元内的危险化学品统计
  addOrUpdateDangerousChemical: '/apps/industrial/addOrUpdateDangerousChemical', // 单元内的危险化学品统计(增,改)
  deleteDangerousChemical: '/apps/industrial/deleteDangerousChemical', // 单元内的危险化学品统计(删除)
  getDangerousGoodsList: '/apps/industrial/getDangerousGoodsList', // 单元内的危险货物统计
  addOrUpdateDangerousGoods: '/apps/industrial/addOrUpdateDangerousGoods', // 单元内的危险货物统计(增,改)
  deleteDangerousGoods: '/apps/industrial/deleteDangerousGoods', // 单元内的危险货物统计(删除)
  getMinePitList: '/apps/industrial/getMinePitList', // 矿坑
  addOrUpdateMinePit: '/apps/industrial/addOrUpdateMinePit', // 矿坑(增,改)
  deleteMinePit: '/apps/industrial/deleteMinePit', // 矿坑(删除)
  getWasteDumpList: '/apps/industrial/getWasteDumpList', // 排土场
  addOrUpdateWasteDump: '/apps/industrial/addOrUpdateWasteDump', // 排土场(增,改)
  deleteWasteDump: '/apps/industrial/deleteWasteDump', // 排土场(删除)
  getMoltMetalFurnaceList: '/apps/industrial/getMoltMetalFurnaceList', // 熔融金属炉
  addOrUpdateMoltMetalFurnace: '/apps/industrial/addOrUpdateMoltMetalFurnace', // 熔融金属炉(增,改)
  deleteMoltMetalFurnace: '/apps/industrial/deleteMoltMetalFurnace', // 熔融金属炉(删除)
  getMagazineList: '/apps/industrial/getMagazineList', // 炸药库
  addOrUpdateMagazine: '/apps/industrial/addOrUpdateMagazine', // 炸药库(增,改)
  deleteMagazine: '/apps/industrial/deleteMagazine', // 炸药库(删除)
  getFireworkStorageList: '/apps/industrial/getFireworkStorageList', // 烟花爆竹库房
  addOrUpdateFireworkStorage: '/apps/industrial/addOrUpdateFireworkStorage', // 烟花爆竹库房(增,改)
  deleteFireworkStorage: '/apps/industrial/deleteFireworkStorage', // 烟花爆竹库房(删除)
  getBuildingList: '/apps/assembly/getBuildingList', // 建筑物（人员密集场所）
  addOrUpdateBuilding: '/apps/assembly/addOrUpdateBuilding', // 建筑物（人员密集场所）(增,改)
  deleteBuilding: '/apps/assembly/deleteBuilding', // 建筑物（人员密集场所）(删除)
  getChemicalList: '/apps/assembly/getChemicalList', // 化学品（学校）
  addOrUpdateChemical: '/apps/assembly/addOrUpdateChemical', // 化学品（学校）(增,改)
  deleteChemical: '/apps/assembly/deleteChemical', // 化学品（学校）(删除)
  getHospitalChemicalList: '/apps/assembly/getHospitalChemicalList', // 医院危险化学品
  addOrUpdateHospitalChemical: '/apps/assembly/addOrUpdateHospitalChemical', // 医院危险化学品(增,改)
  deleteHospitalChemical: '/apps/assembly/deleteHospitalChemical', // 医院危险化学品(删除)
  getHospitalStoreList: '/apps/assembly/getHospitalStoreList', // 储存物质
  addOrUpdateHospitalStore: '/apps/assembly/addOrUpdateHospitalStore', // 储存物质(增,改)
  deleteHospitalStore: '/apps/assembly/deleteHospitalStore', // 储存物质(删除)
  getRailFreightProductRegionList:
    '/apps/industrial/getRailFreightProductRegionList', // 生产加工区(铁路货运站场)
  addOrUpdateRailFreightProductRegion:
    '/apps/industrial/addOrUpdateRailFreightProductRegion', // 生产加工区(铁路货运站场)(增,改)
  deleteRailFreightProductRegion:
    '/apps/industrial/deleteRailFreightProductRegion', // 生产加工区(铁路货运站场)(删除)
  getRailFreightStorageList: '/apps/industrial/getRailFreightStorageList', // 库房(铁路货运站场)
  addOrUpdateRailFreightStorage:
    '/apps/industrial/addOrUpdateRailFreightStorage', // 库房(铁路货运站场)(增,改)
  deleteRailFreightStorage: '/apps/industrial/deleteRailFreightStorage', // 库房(铁路货运站场)(删除)
  getStableLineList: '/apps/facility/getStableLineList', // 固定班线
  addOrUpdateStableLine: '/apps/facility/addOrUpdateStableLine', // 固定班线(增,改)
  deleteStableLine: '/apps/facility/deleteStableLine', // 固定班线(删除)
  getConsequenceAreaList: '/apps/facility/getConsequenceAreaList', // 高后果区
  addOrUpdateConsequenceArea: '/apps/facility/addOrUpdateConsequenceArea', // 高后果区(增,改)
  deleteConsequenceArea: '/apps/facility/deleteConsequenceArea', // 高后果区(删除)
  getVehicleList: '/apps/facility/getVehicleList', // 危货车辆
  addOrUpdateVehicle: '/apps/facility/addOrUpdateVehicle', // 危货车辆(增,改)
  deleteVehicle: '/apps/facility/deleteVehicle', // 危货车辆(删除)
  getBoatList: '/apps/company/getShippingInfo', // 获取船舶信息
  addOrUpdateBoat: '/apps/company/addOrUpdateShippingInfo', // 船舶信息(增,改)
  deleteBoat: '/apps/company/deleteShippingInfo', // 船舶信息删
  getBerthList: '/apps/industrial/getBerthList', // 货物码头泊位
  addOrUpdateBerth: '/apps/industrial/addOrUpdateBerth', // 货物码头泊位(增,改)
  deleteBerth: '/apps/industrial/deleteBerth', // 货物码头泊位(删除)
  getBerthageList: '/apps/industrial/getBerthageList', // 客运码头泊位
  addOrUpdateBerthage: '/apps/industrial/addOrUpdateBerthage', // 客运码头泊位(增,改)
  deleteBerthage: '/apps/industrial/deleteBerthage', // 客运码头泊位(删除)
  getCraneList: '/apps/industrial/getCraneList', // 起重设备
  addOrUpdateCrane: '/apps/industrial/addOrUpdateCrane', // 起重设备(增,改)
  deleteCrane: '/apps/industrial/deleteCrane', // 起重设备(删除)
  getTankFarmList: '/apps/industrial/getTankFarmList', // 罐区
  addOrUpdateTankFarm: '/apps/industrial/addOrUpdateTankFarm', // 罐区(增,改)
  deleteTankFarm: '/apps/industrial/deleteTankFarm', // 罐区(删除)
  getspecialOperationStaffList: '/apps/company/getSpecialOperationPersonList', // 特种作业人员情况查询列表
  addOrUpdatespecialOperationStaff:
    '/apps/company/addOrUpdateSpecialOperationPerson', // 特种作业人员(增,改)
  deletespecialOperationStaff: '/apps/company/deleteSpecialOperationPerson', // 特种作业人员(删除)
  getcredentialsList: '/apps/company/getManagerCertList', // 安全相关负责人情况查询列表
  addOrUpdatecredentials: '/apps/company/addOrUpdateManagerCert', // 安全相关负责人(增,改)
  deletecredentials: '/apps/company/deleteManagerCert', // 安全相关负责人(删除)
  getDangerousTaskList: '/apps/company/getDangerousTaskList', // 危险作业查询列表
  addOrUpdateDangerousTask: '/apps/company/addOrUpdateDangerousTask', // 危险作业(增,改)
  deleteDangerousTask: '/apps/company/deleteDangerousTask', // 危险作业(删除)
  // 石狮六大行业新增
  getLiftingList: '/apps/industrial/getLiftingList', // 起重设备
  addOrUpdateLifting: '/apps/industrial/addOrUpdateLifting', // 起重设备(增,改)
  deleteLifting: '/apps/industrial/deleteLifting', // 起重设备(删除)
  getHazardousWasteList: '/apps/industrial/getHazardousWasteList', // 危险废物
  addOrUpdateHazardousWaste: '/apps/industrial/addOrUpdateHazardousWaste', // 危险废物(增,改)
  deleteHazardousWaste: '/apps/industrial/deleteHazardousWaste', // 危险废物(删除)
  getLandfillsList: '/apps/industrial/getLandfillsList', // 填埋场
  addOrUpdateLandfills: '/apps/industrial/addOrUpdateLandfills', // 填埋场(增,改)
  deleteLandfills: '/apps/industrial/deleteLandfills', // 填埋场(删除)
  getProcessPowerList: '/apps/industrial/getProcessPowerList', // 处理能力
  addOrUpdateProcessPower: '/apps/industrial/addOrUpdateProcessPower', // 处理能力(增,改)
  deleteProcessPower: '/apps/industrial/deleteProcessPower', // 处理能力(删除)
  getShipList: '/apps/company/getShippingInfo', // 货运船舶信息
  addOrUpdateShip: '/apps/company/addOrUpdateShippingInfo', // 货运船舶信息(增,改)
  deleteShip: '/apps/company/deleteShippingInfo', // 货运船舶信息(删除)
  getLegalRegistrationList: '/apps/industrial/getLegalRegistrationList', // 其他法人登记证书
  addOrUpdateLegalRegistration: '/apps/industrial/addOrUpdateLegalRegistration', // 其他法人登记证书(增,改)
  deleteLegalRegistration: '/apps/industrial/deleteLegalRegistration', // 其他法人登记证书(删除)
  getBoilerList: '/apps/industrial/getBoilerList', // 锅炉
  addOrUpdateBoiler: '/apps/industrial/addOrUpdateBoiler', // 锅炉(增,改)
  deleteBoiler: '/apps/industrial/deleteBoiler', // 锅炉(删除)
  getPressureVesselList: '/apps/industrial/getPressureVesselList', // 压力容器
  addOrUpdatePressureVessel: '/apps/industrial/addOrUpdatePressureVessel', // 压力容器(增,改)
  deletePressureVessel: '/apps/industrial/deletePressureVessel', // 压力容器(删除)
  getPressurePipeList: '/apps/industrial/getPressurePipeList', // 压力管道
  addOrUpdatePressurePipe: '/apps/industrial/addOrUpdatePressurePipe', // 压力管道(增,改)
  deletePressurePipe: '/apps/industrial/deletePressurePipe', // 压力管道(删除)
  getDrugSafetyAccessList: '/apps/industrial/getDrugSafetyAccessList', // 非药品类易制毒化学品许可证
  addOrUpdateDrugSafetyAccess: '/apps/industrial/addOrUpdateDrugSafetyAccess', // 非药品类易制毒化学品许可证(增,改)
  deleteDrugSafetyAccess: '/apps/industrial/deleteDrugSafetyAccess', // 非药品类易制毒化学品许可证(删除)
  getChemicalSafetyAccessList: '/apps/industrial/getChemicalSafetyAccessList', // 危险化学品安全许可
  addOrUpdateChemicalSafetyAccess:
    '/apps/industrial/addOrUpdateChemicalSafetyAccess', // 危险化学品安全许可(增,改)
  deleteChemicalSafetyAccess: '/apps/industrial/deleteChemicalSafetyAccess', // 危险化学品安全许可(删除)
  getDesignAcceptanceList: '/apps/industrial/getDesignAcceptanceList', // 设计与验收
  addOrUpdateDesignAcceptance: '/apps/industrial/addOrUpdateDesignAcceptance', // 设计与验收(增,改)
  deleteDesignAcceptance: '/apps/industrial/deleteDesignAcceptance', // 设计与验收(删除)
  getEmergencyPlanList: '/apps/industrial/getEmergencyPlanList', // 应急演练
  addOrUpdateEmergencyPlan: '/apps/industrial/addOrUpdateEmergencyPlan', // 应急演练(增,改)
  deleteEmergencyPlan: '/apps/industrial/deleteEmergencyPlan', // 应急演练(删除)
  getContingencyDrillAssessProjectList:
    '/apps/standard/getContingencyDrillAssessProjectList',
  addOrUpdateContingencyDrillAssessProject:
    '/apps/standard/addOrUpdateContingencyDrillAssessProject',
  deleteContingencyDrillAssessProject:
    '/apps/standard/deleteContingencyDrillAssessProject',
  getThunderCheckSystemList: '/apps/industrial/getThunderCheckSystemList', // 防雷检测
  addOrUpdateThunderCheckSystem:
    '/apps/industrial/addOrUpdateThunderCheckSystem', // 防雷检测(增,改)
  deleteThunderCheckSystem: '/apps/industrial/deleteThunderCheckSystem', // 防雷检测(删除)
  getHiddenTroubleList: '/apps/company/getHiddenTroubleList', // 隐患治理
  addOrUpdateHiddenTrouble: '/apps/company/addOrUpdateHiddenTrouble', // 隐患治理(增,改)
  deleteHiddenTrouble: '/apps/company/deleteHiddenTrouble', // 隐患治理(删除)
  getPortSafetyAccessList: '/apps/industrial/getPortSafetyAccessList', // 港口经营许可证
  addOrUpdatePortSafetyAccess: '/apps/industrial/addOrUpdatePortSafetyAccess', // 港口经营许可证(增,改)
  deletePortSafetyAccess: '/apps/industrial/deletePortSafetyAccess', // 港口经营许可证(删除)
  getPortDangerCertList: '/apps/industrial/getPortDangerCertList', // 港口危险货物作业附证(表格)
  addOrUpdatePortDangerCert: '/apps/industrial/addOrUpdatePortDangerCert', // 港口危险货物作业附证(增,改)
  deletePortDangerCert: '/apps/industrial/deletePortDangerCert', // 港口危险货物作业附证(删除)
  getSafetyEngineerList: '/apps/company/getSafetyEngineerList', // 企业注册安全工程师(表格)
  addOrUpdateSafetyEngineer: '/apps/company/addOrUpdateSafetyEngineer', // 企业注册安全工程师(增,改)
  deleteSafetyEngineer: '/apps/company/deleteSafetyEngineer', // 企业注册安全工程师(删除)
  getGasSafetyAccessList: '/apps/industrial/getGasSafetyAccessList', // 燃气经营许可证(表格)
  addOrUpdateGasSafetyAccess: '/apps/industrial/addOrUpdateGasSafetyAccess', // 燃气经营许可证(增,改)
  deleteGasSafetyAccess: '/apps/industrial/deleteGasSafetyAccess', // 燃气经营许可证(删除)
  getPowerBusAccessList: '/apps/industrial/getPowerBusAccessList', // 电力业务许可证(表格)
  addOrUpdatePowerBusAccess: '/apps/industrial/addOrUpdatePowerBusAccess', // 电力业务许可证(增,改)
  deletePowerBusAccess: '/apps/industrial/deletePowerBusAccess', // 电力业务许可证(删除)
  getBoomAccessList: '/apps/industrial/getBoomAccessList', // 电力业务许可证(表格)
  addOrUpdateBoomAccess: '/apps/industrial/addOrUpdateBoomAccess', // 电力业务许可证(增,改)
  deleteBoomAccess: '/apps/industrial/deleteBoomAccess', // 电力业务许可证(删除)
  getEnterpriseLevelList: '/apps/industrial/getEnterpriseLevelList', // 企业类（级）别(表格)
  addOrUpdateEnterpriseLevel: '/apps/industrial/addOrUpdateEnterpriseLevel', // 企业类（级）别(增,改)
  deleteEnterpriseLevel: '/apps/industrial/deleteEnterpriseLevel', // 企业类（级）别(删除)
  getSaftyProductAccessList: '/apps/industrial/getSaftyProductAccessList', // 安全生产许可证(表格)
  addOrUpdateSaftyProductAccess:
    '/apps/industrial/addOrUpdateSaftyProductAccess', // 安全生产许可证(增,改)
  deleteSaftyProductAccess: '/apps/industrial/deleteSaftyProductAccess', // 安全生产许可证(删除)
  getSaftyDisasterExcerciseList:
    '/apps/industrial/getSaftyDisasterExcerciseList', // 演练(表格)
  addOrUpdateSaftyDisasterExcercise:
    '/apps/industrial/addOrUpdateSaftyDisasterExcercise', // 演练(增,改)
  deleteSaftyDisasterExcercise: '/apps/industrial/deleteSaftyDisasterExcercise', // 演练(删除)
  getFireworksAccessList: '/apps/industrial/getFireworksAccessList', // 烟花爆竹(表格)
  addOrUpdateFireworksAccess: '/apps/industrial/addOrUpdateFireworksAccess', // 烟花爆竹(增,改)
  deleteFireworksAccess: '/apps/industrial/deleteFireworksAccess', // 烟花爆竹(删除)
  getRestaurantAccessList: '/apps/assembly/getRestaurantAccessList', // 餐饮许可证(表格)
  addOrUpdateRestaurantAccess: '/apps/assembly/addOrUpdateRestaurantAccess', // 餐饮许可证(增,改)
  deleteRestaurantAccess: '/apps/assembly/deleteRestaurantAccess', // 餐饮许可证(删除)
  getHotelAccessList: '/apps/assembly/getHotelAccessList', // 宾馆(表格)
  addOrUpdateHotelAccess: '/apps/assembly/addOrUpdateHotelAccess', // 宾馆(增,改)
  deleteHotelAccess: '/apps/assembly/deleteHotelAccess', // 宾馆(删除)
  getSchoolAccessList: '/apps/assembly/getSchoolAccessList', // 学校(表格)
  addOrUpdateSchoolAccess: '/apps/assembly/addOrUpdateSchoolAccess', // 学校(增,改)
  deleteSchoolAccess: '/apps/assembly/deleteSchoolAccess', // 学校(删除)
  getOilSaleAccessList: '/apps//industrial/getOilSaleAccessList', // 成品油(表格)
  addOrUpdateOilSaleAccess: '/apps//industrial/addOrUpdateOilSaleAccess', // 成品油(增,改)
  deleteOilSaleAccess: '/apps//industrial/deleteOilSaleAccess', // 成品油(删除)
  // 医疗机构
  getOxygenTankList: '/apps/assembly/getOxygenTankList', // 液氧储罐(表格)
  addOrUpdateOxygenTank: '/apps/assembly/addOrUpdateOxygenTank', // 液氧储罐(表格)(增,改)
  deleteOxygenTank: '/apps/assembly/deleteOxygenTank', // 液氧储罐(表格)(删除)
  getHospitalAccessList: '/apps/assembly/getHospitalAccessList', // 医疗机构职业许可证(表格)
  addOrUpdateHospitalAccess: '/apps/assembly/addOrUpdateHospitalAccess', // 医疗机构职业许可证(表格)(增,改)
  deleteHospitalAccess: '/apps/assembly/deleteHospitalAccess', // 医疗机构职业许可证(表格)(删除)
  // 危化生产
  getProductStoreEquipmentList: '/apps/industrial/getProductStoreEquipmentList', // 危险化学品生产、储存装置(表格)
  addOrUpdateProductStoreEquipment:
    '/apps/industrial/addOrUpdateProductStoreEquipment', // 危险化学品生产、储存装置(表格) (增,改)
  deleteProductStoreEquipment: '/apps/industrial/deleteProductStoreEquipment', // 危险化学品生产、储存装置(删除)
  // 施工项目
  getConstructionAccessList: '/apps/assembly/getConstructionAccessList', // 施工许可(表格)
  addOrUpdateConstructionAccess: '/apps/assembly/addOrUpdateConstructionAccess', // 施工许可(表格) (增,改)
  deleteConstructionAccess: '/apps/assembly/deleteConstructionAccess', // 施工许可(删除)
  // 导出
  export: '/apps/company/export',
  // 小规模企业
  getIndustryByParentId: '/apps/dictionary/getIndustryByParentId', // 获取行业门类
  getAreaByParentId: '/apps/dictionary/getAreaByParentId', // 获取地址
  // ----------------
  // 风险数据库
  getDbRiskList: '/apps/db/getDbRiskList', // 查询
  addRiskFromDb: '/apps/dynamic/addRiskFromDb', // 从数据库添加风险点(可多选)
  getRiskMatrixForConfig: '/apps/dynamic/getRiskMatrixForConfig', // 获取风险矩阵配置
  updateRiskMatrix: '/apps/dynamic/updateRiskMatrix', // 获取风险矩阵配置

  // 风险矩阵
  getRiskMatrixForSelect: '/apps/dynamic/getRiskMatrixForSelect', // 查询

  // 获取员工接口（新）
  getStaffAccountList: '/apps/dynamic/getStaffAccountList',

  // 获取风险点列表
  getDictionaryRiskSourceList: '/apps/dynamic/getRiskSourceList',
  getRiskSourceList: '/apps/risk/getRiskSourceList', // 风险列表
  addOrUpdateRiskSource: '/apps/risk/addOrUpdateRiskSource',
  deleteRiskSource: '/apps/dynamic/deleteRiskSource',
  getHiddenCheckTableItemList: '/apps/hidden/getHiddenCheckTableItemList', // 风险检查表
  addOrUpdateHiddenCheckTableItem:
    '/apps/hidden/addOrUpdateHiddenCheckTableItem',
  deleteHiddenCheckTableItem: '/apps/hidden/deleteHiddenCheckTableItem',
  getHiddenDangerTwoList: '/apps/dynamic/getHiddenDangerList', // 隐患清单
  getHiddenDangerByOverTimeList:
    '/apps/statistics/getHiddenDangerByOverTimeList',
  addOrUpdateHiddenDanger: '/apps/dynamic/addOrUpdateHiddenDanger', // 隐患清单(增加修改)
  deleteHiddenDangerTwo: '/apps/dynamic/deleteHiddenDanger', // 隐患删除
  deleteHiddenDanger: '/apps/dynamic/deleteHiddenDanger',
  calcRiskInfo: '/apps/dynamic/calcRiskInfo', // 计算风险等级

  // 商场市场
  getMotorList: '/apps/industrial/getMotorList', // 场内机动车辆
  addOrUpdateMotor: '/apps/industrial/addOrUpdateMotor', // 场内机动车辆(增,改)
  deleteMotor: '/apps/industrial/deleteMotor', // 场内机动车辆(删除)

  getAmusementList: '/apps/industrial/getAmusementList', // 大型游乐设施
  addOrUpdateAmusement: '/apps/industrial/addOrUpdateAmusement', // 大型游乐设施(增,改)
  deleteAmusement: '/apps/industrial/deleteAmusement', // 大型游乐设施(删除)

  getElevatorList: '/apps/industrial/getElevatorList', // 电梯
  addOrUpdateElevator: '/apps/industrial/addOrUpdateElevator', // 电梯(增,改)
  deleteElevator: '/apps/industrial/deleteElevator', // 电梯(删除)

  // 定期填报提交
  submitFixRisk: '/apps/dynamic/submitFixRisk',
  checkRiskSourceItem: '/apps/dynamic/checkRiskSourceItem',

  getBaseControlIndustry: '/apps/dictionary/getBaseControlIndustry', // 细分行业
  // 复核历史
  getCompanyReviewLog: '/apps/company/getCompanyReviewLog',
  getInfo: '/apps/admin/getInfo',
  getDictionaryRiskUnitList: '/apps/dictionary/getRiskUnitList',
  // 获取管控层级配置
  getRiskControlLevelForConfig: '/apps/dynamic/getRiskControlLevelForConfig',
  // 更新管控层级配置
  updateRiskControlLevel: '/apps/dynamic/updateRiskControlLevel',
  // 隐患检查项获取接口
  getHiddenCheckList: '/apps/dynamic/getHiddenCheckList',
  // 隐患检查项提交接口
  submitHiddenCheckList: '/apps/dynamic/submitHiddenCheckList',
  // 安全管理制度
  getCompanySaftySystem: '/apps/dynamic/getCompanySaftySystem',
  addOrUpdateCompanySaftySystem: '/apps/dynamic/addOrUpdateCompanySaftySystem',
  getCompanySaftyFileList: '/apps/dynamic/getCompanySaftyFileList',
  addOrUpdateCompanySaftyFile: '/apps/dynamic/addOrUpdateCompanySaftyFile',
  deleteCompanySaftyFile: '/apps/dynamic/deleteCompanySaftyFile',
  // 标准化（文件管理）模块接口
  getStandardNodeTree: '/apps/standard/getStandardNodeTree',
  addOrUpdateStandardN: '/apps/standard/addOrUpdateStandardNode',
  deleteStandardNod: '/apps/standard/deleteStandardNode',

  getStandardFileList: '/apps/standard/getStandardFileList',
  uploadStandard: '/apps/standard/uploadStandardFile',
  addOrUpdateStandardFile: '/apps/standard/addOrUpdateStandardFile',
  deleteStandard: '/apps/standard/deleteStandardFile',

  // smc移植过来的接口 ----------------------------------------------
  getDepartmentStaffList: '/apps/organization/getOrganizationTree', // 获取部门列表
  addOrUpdateDepartmentStaff: '/apps/organization/addOrUpdateOrganization',
  deleteDepartmentStaff: '/apps/organization/deleteOrganization',
  // 人员花名册
  getProductionStaffList: '/apps/staff/getProductionStaffList', // 人员信息
  addOrUpdateProductionStaff: '/apps/staff/addOrUpdateProductionStaff',
  deleteProductionStaff: '/apps/staff/deleteProductionStaff',
  // 场所信息
  getBuildingsList: '/apps/build/getRiskBuildingList', // 场所信息
  addOrUpdateBuildings: '/apps/build/addOrUpdateRiskBuilding',
  deleteBuildings: '/apps/build/deleteRiskBuilding',
  // 设备设施清单
  getMainProductionEquipmentList: '/apps/device/getMainProductionEquipmentList', // 主要生产设备
  addOrUpdateMainProductionEquipment:
    '/apps/device/addOrUpdateMainProductionEquipment',
  deleteMainProductionEquipment: '/apps/device/deleteMainProductionEquipment',

  getAuxiliaryEquipmentList: '/apps/device/getAuxiliaryEquipmentList', // 辅助设备
  addOrUpdateAuxiliaryEquipment: '/apps/device/addOrUpdateAuxiliaryEquipment',
  deleteAuxiliaryEquipment: '/apps/device/deleteAuxiliaryEquipment',

  getSpecialEquipmentList: '/apps/device/getSpecialEquipmentList', // 特种设备
  addOrUpdateSpecialEquipment: '/apps/device/addOrUpdateSpecialEquipment',
  deleteSpecialEquipment: '/apps/device/deleteSpecialEquipment',

  getSafetyAccessoriesList: '/apps/device/getSafetyAccessoriesList', // 安全附件
  addOrUpdateSafetyAccessories: '/apps/device/addOrUpdateSafetyAccessories',
  deleteSafetyAccessories: '/apps/device/deleteSafetyAccessories',
  // 作业活动清单
  getActivityList: '/apps/activity/getActivityList', // 作业活动
  addOrUpdateActivity: '/apps/activity/addOrUpdateActivity',
  deleteActivity: '/apps/activity/deleteActivity',

  getContractorOrganizationTree:
    '/apps/organization/getContractorOrganizationTree', // 承包商
  getSupplierOrganizationTree: '/apps/organization/getSupplierOrganizationTree', // 供应商
  getDepartmentOrganizationTree:
    '/apps/organization/getDepartmentOrganizationTree', // 本企业

  // 专项巡查
  getSpecialCheckList: '/apps/special/getSpecialCheckList', // 获取专项巡查
  addOrUpdateSpecialCheck: '/apps/special/addOrUpdateSpecialCheck', // 更新巡查项目
  deleteSpecialCheck: '/apps/special/deleteSpecialCheck', // 删除巡查项目

  getDbRiskCheckList: '/apps/db/getDbRiskCheckList', // 专业列表
  addOrUpdateDbRiskCheck: '/apps/db/addOrUpdateDbRiskCheck', // 增加或更新
  deleteDbRiskCheck: '/apps/db/deleteDbRiskCheck', // 专业列表

  getDbRiskItemList: '/apps/db/getDbRiskItemList', // 风险数据库风险项列表
  addOrUpdateDbRiskItem: '/apps/db/addOrUpdateDbRiskItem', // 增改
  deleteDbRiskItem: '/apps/db/deleteDbRiskItem', // 删除
  importDbRisk: '/apps/db/importDbRisk', // 导入

  // 事件管理
  handleWarn: '/apps/warn/handleWarn',
  addHiddenDangerFormWarn: '/apps/warn/addHiddenDangerFromWarn', // 生成隐患处理
  deleteWarn: '/apps/warn/deleteWarn', // 删除预警

  // 风险点（新）
  getRiskCheckList: '/apps/dynamic/getRiskCheckList', //
  addOrUpdateRiskCheck: '/apps/dynamic/addOrUpdateRiskCheck', // 增改
  deleteRiskCheck: '/apps/dynamic/deleteRiskCheck', // 删除

  // 检查清单管理
  getRiskCheckTableList: '/apps/dynamic/getRiskCheckTableList',
  getCheckRecordStatsList: '/apps/company/getCheckRecordStatsList',

  // 风险管控计划
  getRiskControlPlan: '/apps/dynamic/getRiskControlPlan',

  // 设置员工检查频次
  setCheckFrequencyType: '/apps/dynamic/setCheckFrequencyType',

  getActivityApplyList: '/apps/activity/getActivityApplyList', // 特殊作业审批
  getSpecialWorkList: '/apps/work/getSpecialWorkList', // 作业管理
  addOrUpdateSpecialWork: '/apps/work/addOrUpdateSpecialWork', //
  deleteSpecialWork: '/apps/work/deleteSpecialWork', //
  closeSpecialWork: '/apps/work/closeSpecialWork', // 关闭作业
  getSpecialWorkCount: '/apps/work/getSpecialWorkCount', // 获取未完成，逾期未处理的数量
  getRiskSourceByCascade: '/apps/risk/getRiskSourceByCascade',

  // 查询专项排查可以选择的员工列表
  getSpecialCheckStaffList: '/apps/special/getSpecialCheckStaffList',
  // 查询"检查清单管理"表格标题项列表
  getRiskCheckTableTitleList: '/apps/dynamic/getRiskCheckTableTitleList',
  // 隐患治理上报
  addOrUpdateHiddenCheckRecord: '/apps/hidden/addOrUpdateHiddenCheckRecord',
  // 培训计划
  deleteTrainPlan: '/apps/train/deleteTrainPlan',
  addOrUpdateTrainPlan: '/apps/train/addOrUpdateTrainPlan',
  getTrainPlanList: '/apps/train/getTrainPlanList',

  // 培训课程
  deleteTrainCourse: '/apps/train/deleteTrainCourse',
  addOrUpdateTrainCourse: '/apps/train/addOrUpdateTrainCourse',
  getTrainCourseList: '/apps/train/getTrainCourseList',

  // 培训课程现场照片
  deleteTrainCoursePhoto: '/apps/train/deleteTrainCoursePhoto',
  addOrUpdateTrainCoursePhoto: '/apps/train/addOrUpdateTrainCoursePhoto',
  getTrainCoursePhotoList: '/apps/train/getTrainCoursePhotoList',

  // 培训课程签到信息
  deleteTrainCourseSign: '/apps/train/deleteTrainCourseSign',
  addOrUpdateTrainCourseSign: '/apps/train/addOrUpdateTrainCourseSign',
  getTrainCourseSignList: '/apps/train/getTrainCourseSignList',

  // 企业的危险作业列表
  getDangerActivityListOfCompany:
    '/apps/activity/getDangerActivityListOfCompany',

  // 安全组织机构
  deleteManagerCert: '/apps/company/deleteManagerCert',
  addOrUpdateManagerCert: '/apps/company/addOrUpdateManagerCert',
  getManagerCertList: '/apps/company/getManagerCertList',

  // 三项岗位
  deleteStaffTrainList: '/apps/standard/deleteStaffTrainList',
  addOrUpdateStaffTrain: '/apps/standard/addOrUpdateStaffTrain',
  getStaffTrainList: '/apps/standard/getStaffTrainList',

  // 三违"行为记录
  deleteViolationRecord: '/apps/standard/deleteViolationRecord',
  addOrUpdateViolationRecord: '/apps/standard/addOrUpdateViolationRecord',
  getViolationRecordList: '/apps/standard/getViolationRecordList',

  // 应急设备设施台账
  deleteEmergencyFacility: '/apps/standard/deleteEmergencyFacility',
  addOrUpdateEmergencyFacility: '/apps/standard/addOrUpdateEmergencyFacility',
  getEmergencyFacilityList: '/apps/standard/getEmergencyFacilityList',

  // 事故管理台账
  deleteAccidentRecord: '/apps/standard/deleteAccidentRecord',
  addOrUpdateAccidentRecord: '/apps/standard/addOrUpdateAccidentRecord',
  getAccidentRecordList: '/apps/standard/getAccidentRecordList',

  // 消防设施台账
  deleteFireFightingDevice: '/apps/standard/deleteFireFightingDevice',
  addOrUpdateFireFightingDevice: '/apps/standard/addOrUpdateFireFightingDevice',
  getFireFightingDeviceList: '/apps/standard/getFireFightingDeviceList',

  // 消防设施台账
  deleteSafetyFacility: '/apps/standard/deleteSafetyFacility',
  addOrUpdateSafetyFacility: '/apps/standard/addOrUpdateSafetyFacility',
  getSafetyFacilityList: '/apps/standard/getSafetyFacilityList',

  // 防雷设施安管理台账
  deleteLightningProtectionFacilitie:
    '/apps/standard/deleteLightningProtectionFacilitie',
  addOrUpdateLightningProtectionFacilitie:
    '/apps/standard/addOrUpdateLightningProtectionFacilitie',
  getLightningProtectionFacilitieList:
    '/apps/standard/getLightningProtectionFacilitieList',

  // 安全警示标志台账
  deleteSafetyWarningMark: '/apps/standard/deleteSafetyWarningMark',
  addOrUpdateSafetyWarningMark: '/apps/standard/addOrUpdateSafetyWarningMark',
  getSafetyWarningMarkList: '/apps/standard/getSafetyWarningMarkList',

  // 复制风险点
  addRiskSourceByCopy: '/apps/risk/addRiskSourceByCopy',
  // 单元二维码
  getRiskUnitQrCode: '/apps/page/getRiskUnitQrCode',
  // 应急指挥与救援系统
  deleteRescuePerson: '/apps/standard/deleteRescuePerson',
  addOrUpdateRescuePerson: '/apps/standard/addOrUpdateRescuePerson',
  getRescuePersonList: '/apps/standard/getRescuePersonList',

  // 承包商
  addOrUpdateContractorOrganization:
    '/apps/organization/addOrUpdateContractorOrganization',
  getContractorOrganizationList:
    '/apps/organization/getContractorOrganizationList',

  // 供应商
  addOrUpdateSupplierOrganization:
    '/apps/organization/addOrUpdateSupplierOrganization',
  getSupplierOrganizationList: '/apps/organization/getSupplierOrganizationList',

  // 查询出线上和线下的培训小时
  getStaffTrainTimeStatistics: '/apps/train/getStaffTrainTimeStatistics',

  // 新增员工个人订制检查项
  addOrUpdateRiskPersonalCheck: '/apps/dynamic/addOrUpdateRiskPersonalCheck',

  // 删除员工个人订制检查项
  deleteRiskPersonalCheck: '/apps/dynamic/deleteRiskPersonalCheck',
  // 安全生产法律法规标准清单
  addOrUpdateProductionLawStandard:
    '/apps/standard/addOrUpdateProductionLawStandard',
  getProductionLawStandardList: '/apps/standard/getProductionLawStandardList',
  deleteProductionLawStandard: '/apps/standard/deleteProductionLawStandard',
  // 规章制度
  addOrUpdateProductionRegulation:
    '/apps/standard/addOrUpdateProductionRegulation',
  getProductionRegulationList: '/apps/standard/getProductionRegulationList',
  deleteProductionRegulation: '/apps/standard/deleteProductionRegulation',
  // 操作规程
  addOrUpdateProductionOperation:
    '/apps/standard/addOrUpdateProductionOperation',
  deleteProductionOperation: '/apps/standard/deleteProductionOperation',
  getProductionOperationList: '/apps/standard/getProductionOperationList',

  // 目标与职责
  getSafetyProductionTargetList: '/apps/standard/getSafetyProductionTargetList',
  addOrUpdateSafetyProductionTarget:
    '/apps/standard/addOrUpdateSafetyProductionTarget',
  deleteSafetyProductionTarget: '/apps/standard/deleteSafetyProductionTarget',
  getSafetyProductionDepartmentTargetList:
    '/apps/standard/getSafetyProductionDepartmentTargetList',
  addOrUpdateSafetyProductionDepartmentTarget:
    '/apps/standard/addOrUpdateSafetyProductionDepartmentTarget',
  deleteSafetyProductionDepartmentTarget:
    '/apps/standard/deleteSafetyProductionDepartmentTarget',
  getDepartmentResponsibilityList:
    '/apps/standard/getDepartmentResponsibilityList',
  addOrUpdateDepartmentResponsibility:
    '/apps/standard/addOrUpdateDepartmentResponsibility',
  deleteDepartmentResponsibility:
    '/apps/standard/deleteDepartmentResponsibility',
  getPostResponsibilityList: '/apps/standard/getPostResponsibilityList',
  addOrUpdatePostResponsibility: '/apps/standard/addOrUpdatePostResponsibility',
  deletePostResponsibility: '/apps/standard/deletePostResponsibility',
  getCompanySafetyFeeList: '/apps/standard/getCompanySafetyFeeList',
  addOrUpdateCompanySafetyFee: '/apps/standard/addOrUpdateCompanySafetyFee',
  deleteCompanySafetyFee: '/apps/standard/deleteCompanySafetyFee',
  getMonthlySafetyFeeList: '/apps/standard/getMonthlySafetyFeeList',
  addOrUpdateMonthlySafetyFee: '/apps/standard/addOrUpdateMonthlySafetyFee',
  deleteMonthlySafetyFee: '/apps/standard/deleteMonthlySafetyFee',
  getInsurancePayCertificateList:
    '/apps/standard/getInsurancePayCertificateList',
  addOrUpdateInsurancePayCertificate:
    '/apps/standard/addOrUpdateInsurancePayCertificate',
  deleteInsurancePayCertificate: '/apps/standard/deleteInsurancePayCertificate',
  getSafetyCultureActivityList: '/apps/standard/getSafetyCultureActivityList',
  addOrUpdateSafetyCultureActivity:
    '/apps/standard/addOrUpdateSafetyCultureActivity',
  deleteSafetyCultureActivity: '/apps/standard/deleteSafetyCultureActivity',
  getSafetyProductionTargetCheckList:
    '/apps/standard/getSafetyProductionTargetCheckList',
  addOrUpdateSafetyProductionTargetCheck:
    '/apps/standard/addOrUpdateSafetyProductionTargetCheck',
  deleteSafetyProductionTargetCheck:
    '/apps/standard/deleteSafetyProductionTargetCheck',
  getSafetyProductionDepartmentTargetCheckList:
    '/apps/standard/getSafetyProductionDepartmentTargetCheckList',
  addOrUpdateSafetyProductionDepartmentTargetCheck:
    '/apps/standard/addOrUpdateSafetyProductionDepartmentTargetCheck',
  deleteSafetyProductionDepartmentTargetCheck:
    '/apps/standard/deleteSafetyProductionDepartmentTargetCheck',
  getDepartmentResponsibilityCheckList:
    '/apps/standard/getDepartmentResponsibilityCheckList',
  addOrUpdateDepartmentResponsibilityCheck:
    '/apps/standard/addOrUpdateDepartmentResponsibilityCheck',
  deleteDepartmentResponsibilityCheck:
    '/apps/standard/deleteDepartmentResponsibilityCheck',
  getPostResponsibilityCheckList:
    '/apps/standard/getPostResponsibilityCheckList',
  addOrUpdatePostResponsibilityCheck:
    '/apps/standard/addOrUpdatePostResponsibilityCheck',
  deletePostResponsibilityCheck: '/apps/standard/deletePostResponsibilityCheck',

  // 应急预案
  getContingencyPlanList: '/apps/standard/getContingencyPlanList',
  addOrUpdateContingencyPlan: '/apps/standard/addOrUpdateContingencyPlan',
  deleteContingencyPlan: '/apps/standard/deleteContingencyPlan',
  // 应急组织机构
  getContingencyOrganizationList:
    '/apps/standard/getContingencyOrganizationList',
  addOrUpdateContingencyOrganization:
    '/apps/standard/addOrUpdateContingencyOrganization',
  deleteContingencyOrganization: '/apps/standard/deleteContingencyOrganization',
  // 应急设备设施台账
  getContingencyDeviceList: '/apps/standard/getContingencyDeviceList',
  addOrUpdateContingencyDevice: '/apps/standard/addOrUpdateContingencyDevice',
  deleteContingencyDevice: '/apps/standard/deleteContingencyDevice',

  //  事故管理
  getSafetyProductionAccidentList:
    '/apps/standard/getSafetyProductionAccidentList',
  addOrUpdateSafetyProductionAccident:
    '/apps/standard/addOrUpdateSafetyProductionAccident',
  deleteSafetyProductionAccident:
    '/apps/standard/deleteSafetyProductionAccident',
  // 三同时
  getTreeSameTimeList: '/apps/standard/getTreeSameTimeList',
  addOrUpdateTreeSameTime: '/apps/standard/addOrUpdateTreeSameTime',
  deleteTreeSameTime: '/apps/standard/deleteTreeSameTime',
  // 相关方名录
  getPartnerList: '/apps/standard/getPartnerList',
  addOrUpdatePartner: '/apps/standard/addOrUpdatePartner',
  deletePartner: '/apps/standard/deletePartner',
  // 资质管理
  getPartnerCertList: '/apps/standard/getPartnerCertList',
  addOrUpdatePartnerCert: '/apps/standard/addOrUpdatePartnerCert',
  deletePartnerCert: '/apps/standard/deletePartnerCert',
  // 人员管理
  getPartnerStaffList: '/apps/standard/getPartnerStaffList',
  addOrUpdatePartnerStaff: '/apps/standard/addOrUpdatePartnerStaff',
  deletegetPartnerStaff: '/apps/standard/deletegetPartnerStaff',
  // 相关方单位
  getPartnerUnitList: '/apps/standard/getPartnerUnitList',
  addOrUpdatePartnerUnit: '/apps/standard/addOrUpdatePartnerUnit',
  deletePartnerUnit: '/apps/standard/deletePartnerUnit',
  // 作业区域
  getPartnerWorkAreaList: '/apps/standard/getPartnerWorkAreaList',

  // 主要设备设施台账
  getMainDeviceList: '/apps/standard/getMainDeviceList',
  addOrUpdateMainDevice: '/apps/standard/addOrUpdateMainDevice',
  deleteMainDevice: '/apps/standard/deleteMainDevice',

  // 检维修计划
  getDeviceRepairPlanList: '/apps/standard/getDeviceRepairPlanList',
  addOrUpdateDeviceRepairPlan: '/apps/standard/addOrUpdateDeviceRepairPlan',
  deleteDeviceRepairPlan: '/apps/standard/deleteDeviceRepairPlan',

  // 安全设备设施台账
  getSafetyDeviceList: '/apps/standard/getSafetyDeviceList',
  addOrUpdateSafetyDevice: '/apps/standard/addOrUpdateSafetyDevice',
  deleteSafetyDevice: '/apps/standard/deleteSafetyDevice',

  // 检查维护保养记录
  getDeviceRepairRecordList: '/apps/standard/getDeviceRepairRecordList',
  addOrUpdateDeviceRepairRecord: '/apps/standard/addOrUpdateDeviceRepairRecord',
  deleteDeviceRepairRecord: '/apps/standard/deleteDeviceRepairRecord',

  // 特种设备注册登记台账
  getSpecialDeviceList: '/apps/standard/getSpecialDeviceList',
  addOrUpdateSpecialDevice: '/apps/standard/addOrUpdateSpecialDevice',
  deleteSpecialDevice: '/apps/standard/deleteSpecialDevice',

  // 特种设备日常维修保养记录
  getSpecialDeviceDailyList: '/apps/standard/getSpecialDeviceDailyList',
  addOrUpdateSpecialDeviceDaily: '/apps/standard/addOrUpdateSpecialDeviceDaily',
  deleteSpecialDeviceDaily: '/apps/standard/deleteSpecialDeviceDaily',

  // 特种设备定期检验记录
  getSpecialDeviceCheckList: '/apps/standard/getSpecialDeviceCheckList',
  addOrUpdateSpecialDeviceCheck: '/apps/standard/addOrUpdateSpecialDeviceCheck',
  deleteSpecialDeviceCheck: '/apps/standard/deleteSpecialDeviceCheck',

  // 安全警示标志台账
  deleteSafetySign: '/apps/standard/deleteSafetySign',
  addOrUpdateSafetySign: '/apps/standard/addOrUpdateSafetySign',
  getSafetySignList: '/apps/standard/getSafetySignList',

  // 防雷设施台账
  deleteLightningProtection: '/apps/standard/deleteLightningProtection',
  addOrUpdateLightningProtection:
    '/apps/standard/addOrUpdateLightningProtection',
  getLightningProtectionList: '/apps/standard/getLightningProtectionList',

  //  作业区域
  deletePartnerWorkArea: '/apps/standard/deletePartnerWorkArea',
  addOrUpdatePartnerWorkArea: '/apps/standard/addOrUpdatePartnerWorkArea',

  // 6s管理
  deleteSixManager: '/apps/standard/deleteSixManager',
  addOrUpdateSixManager: '/apps/standard/addOrUpdateSixManager',
  getSixManagerList: '/apps/standard/getSixManagerList',

  // 存在问题记录
  deleteSixManagerProblem: '/apps/standard/deleteSixManagerProblem',
  addOrUpdateSixManagerProblem: '/apps/standard/addOrUpdateSixManagerProblem',
  getSixManagerProblemList: '/apps/standard/getSixManagerProblemList',

  // 三违行为
  deleteUnsafetyView: '/apps/standard/deleteUnsafetyView',
  addOrUpdateUnsafetyView: '/apps/standard/addOrUpdateUnsafetyView',
  getUnsafetyViewList: '/apps/standard/getUnsafetyViewList',

  // 通用性评估
  deleteProductionLawStandardEvaluate:
    '/apps/standard/deleteProductionLawStandardEvaluate',
  addOrUpdateProductionLawStandardEvaluate:
    '/apps/standard/addOrUpdateProductionLawStandardEvaluate',
  getProductionLawStandardEvaluateList:
    '/apps/standard/getProductionLawStandardEvaluateList',

  deleteProductionLawStandardRun:
    '/apps/standard/deleteProductionLawStandardRun',
  addOrUpdateProductionLawStandardRun:
    '/apps/standard/addOrUpdateProductionLawStandardRun',
  getProductionLawStandardRunList:
    '/apps/standard/getProductionLawStandardRunList',

  deleteProductionRegulationTrain:
    '/apps/standard/deleteProductionRegulationTrain',
  addOrUpdateProductionRegulationTrain:
    '/apps/standard/addOrUpdateProductionRegulationTrain',
  getProductionRegulationTrainList:
    '/apps/standard/getProductionRegulationTrainList',

  deleteProductionRegulationCheck:
    '/apps/standard/deleteProductionRegulationCheck',
  addOrUpdateProductionRegulationCheck:
    '/apps/standard/addOrUpdateProductionRegulationCheck',
  getProductionRegulationCheckList:
    '/apps/standard/getProductionRegulationCheckList',

  deleteProductionRegulationReview:
    '/apps/standard/deleteProductionRegulationReview',
  addOrUpdateProductionRegulationReview:
    '/apps/standard/addOrUpdateProductionRegulationReview',
  getProductionRegulationReviewList:
    '/apps/standard/getProductionRegulationReviewList',

  deleteProductionOperationTrain:
    '/apps/standard/deleteProductionOperationTrain',
  addOrUpdateProductionOperationTrain:
    '/apps/standard/addOrUpdateProductionOperationTrain',
  getProductionOperationTrainList:
    '/apps/standard/getProductionOperationTrainList',

  deleteProductionOperationCheck:
    '/apps/standard/deleteProductionOperationCheck',
  addOrUpdateProductionOperationCheck:
    '/apps/standard/addOrUpdateProductionOperationCheck',
  getProductionOperationCheckList:
    '/apps/standard/getProductionOperationCheckList',

  deleteProductionOperationReview:
    '/apps/standard/deleteProductionOperationReview',
  addOrUpdateProductionOperationReview:
    '/apps/standard/addOrUpdateProductionOperationReview',
  getProductionOperationReviewList:
    '/apps/standard/getProductionOperationReviewList',

  deleteContingencyDeviceMaintenance:
    '/apps/standard/deleteContingencyDeviceMaintenance',
  addOrUpdateContingencyDeviceMaintenance:
    '/apps/standard/addOrUpdateContingencyDeviceMaintenance',
  getContingencyDeviceMaintenanceList:
    '/apps/standard/getContingencyDeviceMaintenanceList',

  deleteContingencyDrillProject: '/apps/standard/deleteContingencyDrillProject',
  addOrUpdateContingencyDrillProject:
    '/apps/standard/addOrUpdateContingencyDrillProject',
  getContingencyDrillProjectList:
    '/apps/standard/getContingencyDrillProjectList',
  // 应急演练方案
  getEmergencyDrillPlanRecordList:
    '/apps/standard/getEmergencyDrillPlanRecordList',
  addOrUpdateEmergencyDrillPlanRecord:
    '/apps/standard/addOrUpdateEmergencyDrillPlanRecord',
  deleteEmergencyDrillPlanRecord:
    '/apps/standard/deleteEmergencyDrillPlanRecord',

  addRiskCheckDuty: '/apps/dynamic/addRiskCheckDuty', // 分配岗位
  getJobStaffList: '/apps/company/getJobStaffList', // 岗位员工选择
  deleteRiskCheckDuty: '/apps/dynamic/deleteRiskCheckDuty', // 删除岗位
  deleteRiskCheckDutyList: '/apps/dynamic/deleteRiskCheckDutyList', // 删除风险点下的岗位分配
  // 风险库检查任务
  getCheckDutyList: '/apps/check/getCheckDuty',
  addCheckDuty: '/apps/check/addCheckDuty',
  deleteCheckDuty: '/apps/check/deleteCheckDuty',

  deleteContingencyDrillRecord: '/apps/standard/deleteContingencyDrillRecord',
  addOrUpdateContingencyDrillRecord:
    '/apps/standard/addOrUpdateContingencyDrillRecord',
  getContingencyDrillRecordList: '/apps/standard/getContingencyDrillRecordList',

  deleteContingencyDrillTrain: '/apps/standard/deleteContingencyDrillTrain',
  addOrUpdateContingencyDrillTrain:
    '/apps/standard/addOrUpdateContingencyDrillTrain',
  getContingencyDrillTrainList: '/apps/standard/getContingencyDrillTrainList',

  deleteContingencyDrillLog: '/apps/standard/deleteContingencyDrillLog',
  addOrUpdateContingencyDrillLog:
    '/apps/standard/addOrUpdateContingencyDrillLog',
  getContingencyDrillLogList: '/apps/standard/getContingencyDrillLogList',

  deleteContingencyDrillEvaluate:
    '/apps/standard/deleteContingencyDrillEvaluate',
  addOrUpdateContingencyDrillEvaluate:
    '/apps/standard/addOrUpdateContingencyDrillEvaluate',
  getContingencyDrillEvaluateList:
    '/apps/standard/getContingencyDrillEvaluateList',

  deleteAccidentFourCatch: '/apps/standard/deleteAccidentFourCatch',
  addOrUpdateAccidentFourCatch: '/apps/standard/addOrUpdateAccidentFourCatch',
  getAccidentFourCatchList: '/apps/standard/getAccidentFourCatchList',
  // 事故分析调查报告
  getAccidentAnalysisList: '/apps/standard/getAccidentAnalysisList',
  addOrUpdateAccidentAnalysis: '/apps/standard/addOrUpdateAccidentAnalysis',
  deleteAccidentAnalysis: '/apps/standard/deleteAccidentAnalysis',

  deleteTrainSchedule: '/apps/standard/deleteTrainSchedule',
  addOrUpdateTrainSchedule: '/apps/standard/addOrUpdateTrainSchedule',
  getTrainScheduleList: '/apps/standard/getTrainScheduleList',

  deleteOuterPersonNotice: '/apps/standard/deleteOuterPersonNotice',
  addOrUpdateOuterPersonNotice: '/apps/standard/addOrUpdateOuterPersonNotice',
  getOuterPersonNoticeList: '/apps/standard/getOuterPersonNoticeList',

  deleteOuterPersonSafetyTrain: '/apps/standard/deleteOuterPersonSafetyTrain',
  addOrUpdateOuterPersonSafetyTrain:
    '/apps/standard/addOrUpdateOuterPersonSafetyTrain',
  getOuterPersonSafetyTrainList: '/apps/standard/getOuterPersonSafetyTrainList',
  // 复核
  getRecheckList: '/apps/recheck/getRecheckList',
  addOrUpdateRecheck: '/apps/recheck/addOrUpdateRecheck',
  deleteRecheck: '/apps/recheck/deleteRecheck',
  handleReview: '/apps/company/handleReview',
  handleReviewPass: '/apps/company/handleReviewPass', // 复核完成
  CancelReviewPass: '/apps/company/CancelReviewPass', // 撤销复核完成
  getAllRecheckList: '/apps/recheck/getAllRecheckList',
  getRecheckHistoryList: '/apps/recheck/getRecheckHistoryList', // 复核历史

  // 一企一档-评星
  updateStar: '/apps/company/updateStar',
  getSafetyProductStandardStar: '/apps/company/getSafetyProductStandardStar',
  getCompanyStarHistoryList: '/apps/company/getCompanyStarHistoryList', // 星级评定历史记录
  // 区域管理
  addOrUpdateBaseArea: '/apps/dictionary/addOrUpdateBaseArea', // 增改区域
  getBaseAreaList: '/apps/dictionary/getBaseAreaList', // 获取区域
  deleteBaseArea: '/apps/dictionary/deleteBaseArea', // 删除区域

  // 风险分布配置
  getIndustryRiskLevelList: '/apps/statistics/getIndustryRiskLevel', // 获取区域

  // 系统配置-系统管理-运行参数配置
  getSysSettings: '/apps/setting/getSysSettings',
  updateSysSetting: '/apps/setting/updateSysSetting',

  // 发短信
  sendReviewMessage: '/apps/company/sendReviewMessage',

  addRiskToDb: '/apps/dynamic/addRiskToDb',

  getDbCheckList: '/apps/db/getDbCheckList', // 检查清单
  addOrUpdateDbCheck: '/apps/db/addOrUpdateDbCheckList', // 检查清单
  deleteDbCheck: '/apps/db/deleteDbCheckList', // 检查清单

  getHiddenStandardCheckItemList: '/apps/hidden/getHiddenStandardCheckItemList',
  getHiddenDangerCheckItemList: '/apps/hidden/getHiddenDangerCheckItemList',

  // 隐患治理-隐患整改管理
  getHiddenDangerList: '/apps/statistics/getHiddenDangerList',
  // 隐患治理-重大隐患治理接口
  getBigHiddenDangerList: '/apps/statistics/getBigHiddenDangerList',

  // 统计分析
  getIndustryTypeList: '/apps/company/getIndustryTypeList', //  行业类型统计
  getCompanyScalePlaceList: '/apps/company/getCompanyScalePlaceInfo', // 属地信息
  getCompanyScaleCheckList: '/apps/company/getCompanyScaleCheckInfo', // 监管行业信息
  getCompanyThreeListList: '/apps/company/getCompanyThreeListInfo', // 企业'三张清单'进度表信息
  // 四色安全风险动态监管信息
  getCompanyFourColorRiskList: '/apps/company/getCompanyFourColorRiskInfo', // 区域属地统计
  getCompanyFourColorRiskDepartmentList:
    '/apps/company/getCompanyFourColorRiskDepartmentInfo', // 行业部门统计
  getCompanyFourColorRiskIndustryTypeList:
    '/apps/company/getCompanyFourColorRiskIndustryType', // 行业类型统计

  getSafetyProductionStandardImproveList:
    '/apps/company/getSafetyProductionStandardImproveInfo', // 安全生产标准化达标信息区域属地统计
  getSafetyProductionStandardDepartmentImproveList:
    '/apps/company/getSafetyProductionStandardDepartmentImproveInfo', // 安全生产标准化达标信息行业部门统计
  getHiddenCheckStatsList: '/apps/company/getHiddenCheckStats', // 隐患排查统计-区域
  getHiddenCheckStatsByDepartmentList:
    '/apps/company/getHiddenCheckStatsByDepartment', // 隐患排查统计-行业
  getBigHiddenCheckStatsList: '/apps/company/getBigHiddenCheckStats', // 重大隐患专项绩效统计
  getBigHiddenCheckStatsTwoList: '/apps/company/getBigHiddenCheckStatsTwo', // 重大隐患专项绩效统计二
  getCompanyLoginStatsList: '/apps/company/getCompanyLoginStats', // 企业端用户登录情况统计表
  getDepartmentLoginStatsList: '/apps/company/getDepartmentLoginStats', // 监管端用户登录情况统计表
  // 丰泽区星级评定统计
  getCompanyStarPlaceInfoList: '/apps/company/getCompanyStarPlaceInfo', // 区域属地统计
  getCompanyStarControlInfoList: '/apps/company/getCompanyStarControlInfo', // 行业部门统计
  getCompanyStarIndustryTypeList: '/apps/company/getCompanyStarIndustryType', // 行业类型统计
  // 标准化建设
  getStandardBuildMonthlyDataList:
    '/apps/company/getStandardBuildMonthlyDataList',
  getStandardBuildDataList: '/apps/company/getStandardBuildDataList',

  // 获取企业信息采集率-属地接口
  getCompanyCollectionRatePlaceList:
    '/apps/company/getCompanyCollectionRatePlaceInfo',
  // 获取企业信息采集率-行业部门接口
  getCompanyCollectionRateManageIndustryList:
    '/apps/company/getCompanyCollectionRateManageIndustry',
  // 获取企业信息采集率二-属地接口
  getCompanyInfoCollectionRatePlaceList:
    '/apps/company/getCompanyInfoCollectionRatePlaceInfo',
  // 获取企业信息采集率二-行业部门接口
  getCompanyInfoCollectionRateManageIndustryList:
    '/apps/company/getCompanyInfoCollectionRateManageIndustry',

  // 风险管控
  getRiskManageList: '/apps/company/getRiskManageList',

  // 工作台统计数据
  getPlatFormInfo: '/apps/company/getPlatFormInfo',

  // 危险作业
  getDangerWorkingList: '/apps/company/getDangerWorkingList',

  // 教育培训-企业培训情况
  getTeachAndTrainList: '/apps/company/getTeachAndTrainList',
  // 教育培训-企业人员持证管理
  getCompanyCertificateManagementList:
    '/apps/train/getCompanyCertificateManagementList',
  // 教育培训-在线学习
  getOnlineLearningList: '/apps/company/getOnlineLearningList',
  addOrUpdateOnlineLearning: '/apps/company/addOrUpdateOnlineLearning',
  deleteOnlineLearning: '/apps/company/deleteOnlineLearning',
  getOnlineLearningVideoList: '/apps/company/getOnlineLearningVideoList', // 视频子表
  addOrUpdateOnlineLearningVideo:
    '/apps/company/addOrUpdateOnlineLearningVideo', // 视频子表-编辑
  deleteOnlineLearningVideo: '/apps/company/deleteOnlineLearningVideo', // 视频子表-删除
  // 教育培训-安全宣传
  getSafetyPromotionList: '/apps/company/getSafetyPromotionList',
  addOrUpdateSafetyPromotion: '/apps/company/addOrUpdateSafetyPromotion',
  deleteSafetyPromotion: '/apps/company/deleteSafetyPromotion',
  getSafetyPromotionVideoList: '/apps/company/getSafetyPromotionVideoList', // 视频子表
  addOrUpdateSafetyPromotionVideo:
    '/apps/company/addOrUpdateSafetyPromotionVideo', // 视频子表-编辑
  deleteSafetyPromotionVideo: '/apps/company/deleteSafetyPromotionVideo', // 视频子表-删除

  // 通知公告
  getNoticeList: '/apps/notice/getNoticeList',
  addOrUpdateNotice: '/apps/notice/addOrUpdateNotice',
  deleteNotice: '/apps/notice/delete',
  getReceiveDepartmentNoticeList: '/apps/notice/getReceiveDepartmentNoticeList', // 已收通知
  deleteReceiveDepartmentNotice: '/apps/notice/deleteReceiveDepartmentNotice', // 已收通知-删除
  addReadRecord: '/apps/notice/addReadRecord', // 监管端点击查看通知公告标题时调的已读接口

  // 自评相关
  getPerformanceList: '/apps/performance/getPerformanceList',
  updatePerformanceList: '/apps/performance/updatePerformanceList',
  getPerformanceScore: '/apps/performance/getPerformanceScore',
  // 扣分情况及持续改进
  getPerformanceReduceList: '/apps/performance/getPerformanceReduceList',
  addOrUpdatePerformanceReduce:
    '/apps/performance/addOrUpdatePerformanceReduce',
  deletePerformanceReduce: '/apps/performance/deletePerformanceReduce',

  // 企业隐患清单
  getCompanyHiddenList: '/apps/company/getCompanyHiddenList',
  getAdminCompanyHiddenList: '/apps/company/getAdminCompanyHiddenList', // 隐患排查-企业自查整改-隐患清单列表
  // 检查标准
  getCheckStandardList: '/apps/standard/getCheckStandardList',
  addOrUpdateCheckStandard: '/apps/standard/addOrUpdateCheckStandard',
  deleteCheckStandard: '/apps/standard/deleteCheckStandard',
  importCheckStandardItem: '/apps/standard/importCheckStandardItem',

  // 检查标准项
  getCheckStandardItemList: '/apps/standard/getCheckStandardItemList',
  addOrUpdateCheckStandardItem: '/apps/standard/addOrUpdateCheckStandardItem',
  deleteCheckStandardItem: '/apps/standard/deleteCheckStandardItem',

  // 重大隐患清单
  getCheckHiddenList: '/apps/standard/getCheckHiddenList',
  addOrUpdateCheckHidden: '/apps/standard/addOrUpdateCheckHidden',
  deleteCheckHidden: '/apps/standard/deleteCheckHidden',
  importCheckHiddenItem: '/apps/standard/importCheckHiddenItem',

  // 重大隐患标准项
  getCheckHiddenItemList: '/apps/standard/getCheckHiddenItemList',
  addOrUpdateCheckHiddenItem: '/apps/standard/addOrUpdateCheckHiddenItem',
  deleteCheckHiddenItem: '/apps/standard/deleteCheckHiddenItem',

  // 重大隐患审核
  applyRedHidden: '/apps/gov/applyRedHidden',

  // 销号处理
  handleClosApply: '/apps/gov/handleClosApply',

  // 隐患统计
  getCheckNumData: '/apps/statistics/getCheckNumData',
  getCheckTableDBNum: '/apps/check/getCheckTableDBNum',

  // 危险作业
  getGovSpecialWorkList: '/apps/work/getGovSpecialWorkList',
  // 危险作业统计
  getSpecialWorkDataByType: '/apps/work/getSpecialWorkDataByType',

  // 教育培训统计
  getTeachAndTrainData: '/apps/company/getTeachAndTrainData',

  // 自评表维护
  getMonitorPerformanceList: '/apps/monitor/getMonitorPerformanceList',
  addOrUpdateMonitorPerformance: '/apps/monitor/addOrUpdateMonitorPerformance',
  deleteMonitorPerformance: '/apps/monitor/deleteMonitorPerformance',

  // 获取监督专项检查列表
  getGovSpecialCheckList: '/apps/gov/getGovSpecialCheckList',
  addOrUpdateGovSpecialCheck: '/apps/gov/addOrUpdateGovSpecialCheck',
  addGovSpecialCheck: '/apps/gov/addGovSpecialCheck',
  updateGovSpecialCheck: '/apps/gov/updateGovSpecialCheck',
  deleteGovSpecialCheck: '/apps/gov/deleteGovSpecialCheck',

  // 企业的专家管理
  getGovSpecialCheckCompanyExpertList:
    '/apps/gov/getGovSpecialCheckCompanyExpertList', // gov_check_id   company_id
  addGovSpecialCheckCompanyExpert: '/apps/gov/addGovSpecialCheckCompanyExpert', // gov_check_id   company_id   expert_id
  deleteGovSpecialCheckCompanyExpert:
    '/apps/gov/deleteGovSpecialCheckCompanyExpert', // id

  // 企业的检查清单管理
  getGovSpecialCheckCompanyTableList:
    '/apps/gov/getGovSpecialCheckCompanyTableList', // gov_check_id   company_id
  addGovSpecialCheckCompanyTable: '/apps/gov/addGovSpecialCheckCompanyTable', // gov_check_id   company_id  check_table_id
  deleteGovSpecialCheckCompanyTable:
    '/apps/gov/deleteGovSpecialCheckCompanyTable', // id

  // 监督检查单位列表
  getGovSpecialCheckCompanyList: '/apps/gov/getGovSpecialCheckCompanyList', // gov_check_id
  addGovSpecialCheckCompany: '/apps/gov/addGovSpecialCheckCompany', // gov_check_id    company_id
  deleteGovSpecialCheckCompany: '/apps/gov/deleteGovSpecialCheckCompany', // id
  getHiddenDangerListByGovList: '/apps/gov/getHiddenDangerListByGov',

  // 获取检查专家库
  getSupervisionExportDbList: '/apps/supervision/getSupervisionExportDbList',
  addSupervisionExportDb: '/apps/supervision/addSupervisionExportDb',
  UpdateSupervisionExportDb: '/apps/supervision/updateSupervisionExportDb',
  deleteSupervisionExportDb: '/apps/supervision/deleteSupervisionExportDb',

  // 通知企业进行专项检查
  pushGovCheckToCompany: '/apps/gov/pushGovCheckToCompany',
  //  获取专项检查里面的企业列表
  getCompanyListBySpecialCheck: '/apps/gov/getCompanyListBySpecialCheck',

  getBoatList: '/apps/company/getShippingInfo', // 获取船舶信息
  addOrUpdateBoat: '/apps/company/addOrUpdateShippingInfo', // 改
  deleteBoat: '/apps/company/deleteShippingInfo', // 删

  // 码头信息
  getDockList: '/apps/company/getDockInfo',
  addOrUpdateDock: '/apps/company/addOrUpdateDockInfo',
  deleteDock: '/apps/company/deleteDockInfo',

  // 管理账号配置
  getManagerList: '/apps/admin/getManagerList',
  deleteManager: '/apps/admin/deleteManager',
  addOrUpdateManager: '/apps/admin/addOrUpdateManager',
  manageAccountDeletePasswordCache: '/apps/admin/deletePasswordCache', // 解除锁定

  // 部门列表
  getDepartmentTreeList: '/apps/company/getDepartmentTreeList', //
  addOrUpdateDepartmentTree: '/apps/company/addOrUpdateDepartmentTree', //
  deleteDepartmentTree: '/apps/company/deleteDepartmentTree', //

  // 部分部门列表
  getCommonDepartmentList: '/apps/company/getCommonDepartmentList',
  // 部分乡镇列表
  getSubAreaList: '/apps/company/getSubAreaList',

  getClassifyList: '/apps/auth/getClassifyList', // 获取角色列表
  addOrUpdateClassify: '/apps/auth/addOrUpdateClassify',
  deleteClassify: '/apps/auth/deleteClassify',
  getClassifyPermissionList: '/apps/auth/getClassifyPermissionList', // 获取角色权限
  updateClassifyPermission: '/apps/auth/updateClassifyPermission',
  getPermissionList: '/apps/auth/getPermissionList', // 获取权限列表
  addOrUpdatePermission: '/apps/auth/addPermission', // name code parent_id(根节点传0)
  deletePermission: '/apps/auth/deletePermission',
  // 监管端行业建设情况接口
  getIndustryConstructionList: '/apps/company/getIndustryConstructionList', // 获取列表
  addOrUpdateIndustryConstruction:
    '/apps/company/addOrUpdateIndustryConstruction ', // 修改新增
  // apps/common/getAreaListByParentId 传3502 获取区域接口
  getAreaListByParentId: '/apps/common/getAreaListByParentId', // 获取区域接口
  // apps/common/getControlList
  getControlList: '/apps/common/getControlList', // 获取行业接口
  exportIndustryConstruction: '/apps/company/exportIndustryConstruction', // 表格导出
  // 临时检查对象
  getSupervisionUnitList: '/apps/supervision/getSupervisionUnitList', // 获取列表
  addSupervisionUnit: '/apps/supervision/addSupervisionUnit', // 新增
  updateSupervisionUnit: '/apps/supervision/updateSupervisionUnit', // 修改
  deleteSupervisionUnit: '/apps/supervision/deleteSupervisionUnit', // 删除
  // 检查任务隐患跟踪表
  getSupervisionTaskTraceList: '/apps/supervision/getSupervisionTaskTraceList', // 获取列表
  // 检查层级隐患数统计
  getSupervisionLevelHiddenNumberInfo:
    '/apps/supervision/getSupervisionLevelHiddenNumberInfo', // 获取列表
  // 隐患动态管理
  getHiddenManage: '/apps/supervision/getHiddenManage', // 获取列表
  // 检查任务部署
  getSupervisionTaskList: '/apps/supervision/getSupervisionTaskList', // 获取
  addSupervisionTask: '/apps/supervision/addSupervisionTask', // 新增
  updateSupervisionTask: '/apps/supervision/updateSupervisionTask', // 修改
  deleteSupervisionTask: '/apps/supervision/deleteSupervisionTask', // 删除
  // 任务部署里面表格
  getSupervisionTaskUnitList: '/apps/supervision/getSupervisionTaskUnitList', // 获取
  addSupervisionTaskUnit: '/apps/supervision/addSupervisionTaskUnit', // 新增
  deleteSupervisionTaskUnit: '/apps/supervision/deleteSupervisionTaskUnit', // 删除
  // 监督检查管理
  getSupervisionCheckList: '/apps/supervision/getSupervisionCheckList', // 获取
  addSupervisionCheck: '/apps/supervision/addSupervisionCheck', // 新增
  updateSupervisionCheck: '/apps/supervision/updateSupervisionCheck', // 修改
  deleteSupervisionCheck: '/apps/supervision/deleteSupervisionCheck', // 删除
  // 隐患移交跟踪
  getSupervisionHiddenTraceList:
    '/apps/supervision/getSupervisionHiddenTraceList',
  getIsSafetyDepartment: '/apps/supervision/getIsSafetyDepartment', // 再次移交
  // 新增隐患问题
  getSupervisionCheckHiddenList:
    '/apps/supervision/getSupervisionCheckHiddenList', // 获取
  addSupervisionCheckHidden: '/apps/supervision/addSupervisionCheckHidden', // 新增
  updateSupervisionCheckHidden:
    '/apps/supervision/updateSupervisionCheckHidden', // 修改
  updateSupervisionInspect: '/apps/Supervision/SupervisionInspect', // 修改
  deleteSupervisionCheckHidden:
    '/apps/supervision/deleteSupervisionCheckHidden', // 删除

  getJobList: '/apps/company/getJobList',
  addOrUpdateJob: '/apps/company/addOrUpdateJob',
  deleteJob: '/apps/company/deleteJob',
  // 施工阶段
  getAssessmentConstructionItemList:
    '/apps/unit/getAssessmentConstructionItemList',
  addOrUpdateAssessmentConstructionItem:
    '/apps/unit/addOrUpdateAssessmentConstructionItem',
  deleteAssessmentConstructionItem:
    '/apps/unit/deleteAssessmentConstructionItem',
  // 获取单元对应阶段数
  getAssessmentConstructionItemCount:
    '/apps/unit/getAssessmentConstructionItemCount',
  getHiddenCheckRecordList: '/apps/inspect/getHiddenCheckRecordList',
  // 检查清单维护统一接口传type区分 1：行业领域 2：网格员 3：专项检查  4：重大隐患 5：主体责任
  getCheckTableDBList: '/apps/check/getCheckTableDBList',
  addOrUpdateCheckTableDB: '/apps/check/addOrUpdateCheckTableDB',
  deleteCheckTableDB: '/apps/check/deleteCheckTableDB',
  deleteCheckTableDBByBatch: '/apps/check/deleteCheckTableDBItemByBatch', // 检查项维护 批量删除
  // 检查维护项 同上
  getCheckTableDBItemList: '/apps/check/getCheckTableDBItemList',
  addOrUpdateCheckTableDBItem: '/apps/check/addOrUpdateCheckTableDBItem',
  deleteCheckTableDBItem: '/apps/check/deleteCheckTableDBItem',
  // 检查专家库
  getGovCheckExpertList: '/apps/gov/getGovCheckExpertList',
  addGovCheckExpert: '/apps/gov/addGovCheckExpert',
  updateGovCheckExpert: '/apps/gov/updateGovCheckExpert',
  deleteGovCheckExpert: '/apps/gov/deleteGovCheckExpert',

  // 巡查记录-巡查率统计-风险点巡查统计
  getRiskPointPatrolList: '/apps/inspect/getRiskPointPatrolList',

  // 巡查记录-巡查率统计-责任人巡查统计
  getResponsiblePersonInspectionList:
    '/apps/inspect/getResponsiblePersonInspectionList',

  // 巡查记录-巡查率统计-责任部门巡查统计
  getResponsibleDeparttmentInspectionList:
    '/apps/inspect/getResponsibleDeparttmentInspectionList',

  // 整改清单-统计-时间段隐患整改统计
  getDataHiddenRectifyList: '/apps/inspect/getDataHiddenRectifyList',

  // 整改清单-统计-责任部门隐患整改统计
  getDepartmentHiddenRectifyList:
    '/apps/inspect/getDepartmentHiddenRectifyList',

  // 整改清单-统计-责任人隐患整改统计
  getPersonHiddenRectifyList: '/apps/inspect/getPersonHiddenRectifyList',

  // 标准化建设-评定细则维护
  getAssessmentDetailList: '/apps/company/getAssessmentDetailList', // 获取列表
  addOrUpdateAssessmentDetail: '/apps/company/addOrUpdateAssessmentDetail', // 新增或修改
  deleteAssessmentDetail: '/apps/company/deleteAssessmentDetail', // 删除

  // 应急管理-企业应急预案管理
  getEmergencyPlanManagementList:
    '/apps/standard/getEmergencyPlanManagementList',
  // 应急管理-企业应急物资管理
  getEmergencyMaterialsManagementList:
    '/apps/standard/getEmergencyMaterialsManagementList',
  // 应急管理-企业应急演练管理
  getEmergencyDrillManagementList:
    '/apps/standard/getEmergencyDrillManagementList',

  // 年度应急演练计划
  exportContingencyPlan: '/apps/standard/exportContingencyPlan', // 年度应急演练计划
  getContingencyDrillProjectList:
    '/apps/standard/getContingencyDrillProjectList',

  getControlDepartmentList: '/apps/company/getControlDepartmentList',

  // 获取企业日常任务检查清单
  getRiskSouceCheckRecordList: '/apps/risk/getRiskSouceCheckRecordList', // 查询

  // 自定义检查清单
  getCustomCheckTitle: '/apps/standard/getCustomCheckTitleList',
  addOrUpdateCustomCheck: '/apps/standard/addOrUpdateCustomCheck',
  deleteCustomCheck: '/apps/standard/deleteCustomCheck',
  addOrUpdateCustomCheckTitle: '/apps/standard/addOrUpdateCustomCheckTitle',
  deleteCustomCheckTitle: '/apps/standard/deleteCustomCheckTitle',
  getCompanyCheckTableDBList: '/apps/check/getCompanyCheckTableDBList',

  // 获取指定id自定义清单
  getCustomCheckList: '/apps/standard/getCustomCheckList',

  // 泉州检查清单
  getHiddenStandardCheckIndustryList:
    '/apps/hidden/getHiddenStandardCheckIndustryList',
  getHiddenStandardCheckItemList: '/apps/hidden/getHiddenStandardCheckItemList',

  // 安责险管理-机构管理-保险机构管理
  getInsuranceList: '/apps/insurance/getInsuranceList',
  updateInsurance: '/apps/insurance/updateInsurance', // 是否通过审核
  // 安责险管理-机构管理-保险机构管理-详情
  getInsuranceStaffList: '/apps/insurance/getInsuranceStaffList', // 获取人员信息列表
  //  安责险管理-机构管理-保险机构管理-项目业绩
  getInsuranceRecordOnlineList: '/apps/insurance/getInsuranceRecordOnlineList', // 安全生产责任保险线上业务
  getInsuranceRecordOfflineList:
    '/apps/insurance/getInsuranceRecordOfflineList', // 安全生产责任保险线下业务
  // getInsuranceContractManagementList: '/apps/insurance/getInsuranceContractManagementList', // 安全生产责任保险线下业务

  // 安责险管理-机构管理-服务机构管理
  getAgencyListFirst: '/apps/facilitatingAgency/getAgencyList',
  updateAgencyFirst: '/apps/facilitatingAgency/updateAgency',
  resetAgencyPassword: '/apps/newfacilitating/resetPassword', // 修改密码

  // 安责险管理-机构管理-服务机构管理-详情
  getServiceOrganizationCertificateList:
    '/apps/newfacilitating/getServiceOrganizationCertificateList', // 获取机构证书列表
  getServiceSpecialistList: '/apps/newfacilitating/getServiceSpecialistList', // 获取人员信息列表
  // 安责险管理-机构管理-服务机构管理-项目业绩
  getInsuranceProjectOfflineList:
    '/apps/insurance/getInsuranceProjectOfflineList', // 安全生产责任保险项目
  getOtherProjectList: '/apps/insurance/getOtherProjectList', // 其他类型项目

  // 安责险管理-机构管理-专家库
  getInsuranceTechnicistList: '/apps/insurance/getInsuranceTechnicistList',
  addOrUpdateInsuranceTechnicist:
    '/apps/insurance/addOrUpdateInsuranceTechnicist',
  deleteInsuranceTechnicist: '/apps/insurance/deleteInsuranceTechnicist',
  // 安责险管理-机构管理-专家库-项目业绩
  getInsuranceProjectOfflineSpecialistList:
    '/apps/insurance/getInsuranceProjectOfflineSpecialistList', // 安全生产责任保险项目

  // 安责险管理-机构管理-黑名单
  getAgencyBlackHistoryList:
    '/apps/facilitatingagency/getAgencyBlackHistoryList', // 服务机构
  getInsuranceBlackHistoryList: '/apps/insurance/getInsuranceBlackHistoryList', // 保险机构
  getTechnicistBlackHistoryList:
    '/apps/insurance/getTechnicistBlackHistoryList', // 专家库

  // 安责险管理-抽查
  getSingleInsuranceCheckInfo: '/apps/insurance/getSingleInsuranceCheckInfo', // 获取详情
  addOrUpdateOtherProjectCheck: '/apps/insurance/addOrUpdateOtherProjectCheck', // 机构管理-服务机构管理-项目业绩-其它类型项目 type:1
  addOrUpdateRecordCheck: '/apps/insurance/addOrUpdateRecordCheck', // 保险管理-抽查 type:2
  addOrUpdatePaymentCheck: '/apps/insurance/addOrUpdatePaymentCheck', // 理赔管理-抽查 type:3
  addOrUpdateAccidentPreventCheck:
    '/apps/insurance/addOrUpdateAccidentPreventCheck', // 事故预防-抽查 type:4

  // 安责险管理-保险管理-线上项目
  getInsuranceRecordList: '/apps/insurance/getInsuranceRecordList',
  // 安责险管理-保险管理-线下项目
  getInsuranceContractManagementList:
    '/apps/insurance/getInsuranceContractManagementList',

  // 安责险管理-理赔管理
  getAdminInsurancePayManagementList:
    '/apps/insurance/getAdminInsurancePayManagementList',
  handleInspect: '/apps/insurance/handleInspect',
  handleInputInfo: '/apps/insurance/handleInputInfo', // 录入处理信息
  getInsuranceCheckInfoList: '/apps/insurance/getInsuranceCheckInfoList', // 录入处理信息-现场查勘信息-获取列表
  addOrUpdateInsuranceCheckInfo:
    '/apps/insurance/addOrUpdateInsuranceCheckInfo', // 录入处理信息-现场查勘信息-增改
  deleteInsuranceCheckInfo: '/apps/insurance/deleteInsuranceCheckInfo', // 录入处理信息-现场查勘信息-删除
  getInsuranceLostInfoList: '/apps/insurance/getInsuranceLostInfoList', // 录入处理信息-定损信息-获取列表
  addOrUpdateInsuranceLostInfo: '/apps/insurance/addOrUpdateInsuranceLostInfo', // 录入处理信息-定损信息-增改
  deleteInsuranceLostInfo: '/apps/insurance/deleteInsuranceLostInfo', // 录入处理信息-定损信息-删除
  getInsuranceStaffDeathsInfoList:
    '/apps/insurance/getInsuranceStaffDeathsList', // 录入处理信息-赔付信息-人员人身伤亡信息-获取列表
  addOrUpdateInsuranceStaffDeathsInfo:
    '/apps/insurance/addOrUpdateInsuranceStaffDeathsInfo', // 录入处理信息-赔付信息-人员人身伤亡信息-增改
  deleteInsuranceStaffDeathsInfo:
    '/apps/insurance/deleteInsuranceStaffDeathsInfo', // 录入处理信息-赔付信息-人员人身伤亡信息-删除
  getInsurancePropertyInfoList: '/apps/insurance/getInsurancePropertyList', // 录入处理信息-赔付信息-第三者财产损失-获取列表
  addOrUpdateInsurancePropertyInfo:
    '/apps/insurance/addOrUpdateInsurancePropertyInfo', // 录入处理信息-赔付信息-第三者财产损失-增改
  deleteInsurancePropertyInfo: '/apps/insurance/deleteInsurancePropertyInfo', // 录入处理信息-赔付信息-第三者财产损失-删除

  // 安责险管理-事故预防服务
  getInsuranceProjectList: '/apps/insurance/getInsuranceProjectList', // 获取服务方案
  getPreventionMajorItemsList: '/apps/insurance/getPreventionMajorItemsList', // 服务方案列表
  addorUpdatePreventionMajorItems:
    '/apps/insurance/addorUpdatePreventionMajorItems',
  deletePreventionMajorItems: '/apps/insurance/deletePreventionMajorItems',
  updatePreventionMajorItems: '/apps/insurance/updatePreventionMajorItems', // 编辑服务方案
  receivingUnit: '/apps/insurance/receivingUnit', // 提交服务方案
  companyVisit: '/apps/insurance/companyVisit', // 回访确认
  getInsuranceInfo: '/apps/insurance/getInsuranceInfo',
  getOtherInsuranceProjectList: '/apps/insurance/getOtherInsuranceProjectList', // 其他类型项目

  // 详情界面
  getPreventionMajorDetailList: '/apps/insurance/getPreventionMajorDetailList', //
  updatePreventionMajorDetail: '/apps/insurance/updatePreventionMajorDetail', //
  getAccidentPreventionFileList:
    '/apps/insurance/getAccidentPreventionFileList', // 详情界面-服务方案/服务报告
  addOrUpdateAccidentPreventionFile:
    '/apps/insurance/addOrUpdateAccidentPreventionFile',
  deleteAccidentPreventionFile: '/apps/insurance/deleteAccidentPreventionFile',

  // 教育培训-安全培训学时计划
  getTrainPlanStaffList: '/apps/train/getTrainPlanStaffList', // 学时计划
  addOrUpdateTrainPlanStaff: '/apps/train/addOrUpdateTrainPlanStaff',
  deleteTrainPlanStaff: '/apps/train/deleteTrainPlanStaff',

  // 培训人员
  getTrainStaffList: '/apps/train/getTrainStaffList',
  addOrUpdateTrainStaff: '/apps/train/addOrUpdateTrainStaff',

  // 安责险管理-监督检查-投诉管理
  getInsuranceSubmissionList: '/apps/insurance/getInsuranceSubmissionList', // 获取列表
  addInsuranceSubmissionByPolicy:
    '/apps/insurance/addInsuranceSubmissionByPolicy', // 投保投诉
  addInsuranceSubmissionByClaim:
    '/apps/insurance/addInsuranceSubmissionByClaim', // 理赔投诉
  addInsuranceSubmissionByAccident:
    '/apps/insurance/addInsuranceSubmissionByAccident', // 事故预防投诉
  updateSubmission: '/apps/insurance//updateSubmission', // 更新投诉

  // 安责险服务-监督管理-信用等级管理
  getInsuranceEvaluationList: '/apps/insurance/getInsuranceEvaluationList', // 获取保险机构信用等级
  getFacilitatingEvaluationList:
    '/apps/insurance/getFacilitatingEvaluationList', // 获取服务机构信用等级
  getInsuranceEvaluationTableList:
    '/apps/insurance/getInsuranceEvaluationTableList', // 获取满意度详情

  getAccidentPreventionStaffList:
    '/apps/insurance/getAccidentPreventionStaffList',
  addOrUpdateAccidentPreventionStaff:
    '/apps/insurance/addOrUpdateAccidentPreventionStaff',
  deleteAccidentPreventionStaff:
    '/apps/insurance/deleteAccidentPreventionStaff',

  // 安责险管理-统计分析-投保企业统计查询
  getRecordCompanyAreaStatsList: '/apps/insurance/getRecordCompanyAreaStats', // 区域统计
  getRecordCompanyIndustryStatsList:
    '/apps/insurance/getRecordCompanyIndustryStats', // 行业统计
  // 安责险管理-统计分析-保险公司业绩查询
  getInsuranceCompanyStatsList: '/apps/insurance/getInsuranceCompanyStats',
  // 安责险管理-统计分析-服务费用统计
  getServiceFeeStatsList: '/apps/insurance/getServiceFeeStats',

  // 操作日志
  getOperationLogList: '/apps/requestlog/getList',
  deleteOperationLog: '/apps/requestlog/delete',
  // 登录日志
  // getEntryLogList: '/apps/loginlog/getList',
  getListByCompany: '/apps/loginlog/getListByCompany', // 企业登录日志
  getListByGov: '/apps/loginlog/getListByGov', // 政府登录日志
  deleteEntryLog: '/apps/loginlog/delete',

  // 5s管理
  get5sCheckDutyList: '/apps/fivesCheck/get5scheckDuty',
  add5sCheckDuty: '/apps/fivesCheck/add5scheckDuty',
  delete5sCheckDuty: '/apps/fivesCheck/delete5scheckDuty',
  update5sCheckDuty: '/apps/fivesCheck/update5scheckDuty',
  addOrUpdate5sCheckRecord: '/apps/fivesCheck/addOrUpdate5sCheckRecord', // 新增检查记录
  get5sCheckRecordList: '/apps/fivesCheck/get5sCheckRecordList', // 获取巡查记录
  delete5sCheckRecord: '/apps/fivesCheck/delete5sCheckRecord', // 删除巡查记录

  // 风险公告列表
  getSafetyProductionTargetMissionList:
    '/apps/standard/getSafetyProductionTargetMissionList',
  addOrUpdateSafetyProductionTargetMission:
    '/apps/standard/addOrUpdateSafetyProductionTargetMission',
  deleteSafetyProductionTargetMission:
    '/apps/standard/deleteSafetyProductionTargetMission',

  // 获取任务列表：apps/standard/getTaskRecordList 传id;
  getTaskRecordList: '/apps/standard/getTaskRecordList',
  // 获取工作列表  传responsibility_list_id 职责清单id
  getWorkTaskList: '/apps/standard/getWorkTaskList',

  // 专家服务-专家选派
  getExpertSelectList: '/apps/company/getExpertSelectList',
  addOrUpdateExpertSelect: '/apps/company/addOrUpdateExpertSelect',
  deleteExpertSelect: '/apps/company/deleteExpertSelect',
  getExpertWorkList: '/apps/company/getExpertWorkList', // 子表-查询
  addOrUpdateExpertWork: '/apps/company/addOrUpdateExpertWork', // 子表-新增/修改
  deleteExpertWork: '/apps/company/deleteExpertWork', // 子表-删除
  // 专家服务-专家管理
  getExpertList: '/apps/company/getExpertList', // 获取专家管理列表
  addOrUpdateExpert: '/apps/company/addOrUpdateExpert', // 新增
  deleteExpert: '/apps/company/deleteExpert', // 删除
  deleteExpertByBatch: '/apps/company/deleteExpertByBatch', // 批量删除

  getContinuouslyImproveList: '/apps/standard/getContinuouslyImproveList', // 自评明细
  getPerformanceReduceList: '/apps/performance/getPerformanceReduceList', // 自拍改进

  // 九小场所-首页
  getNineMiniPlatFormInfoList: '/apps/nineminicompany/getNineMiniPlatFormInfo',

  // 九小场所-场所自查-巡查记录
  getNineMiniCompanyRecordList:
    '/apps/nineminicompany/getNineMiniCompanyRecordList', // 获取列表
  getCompanyHiddenCheckRecordList:
    '/apps/nineminicompany/getCompanyHiddenCheckRecordList', // 操作列巡查记录和自查次数的界面
  getCompanyHiddenCheckRecordItemResultList:
    '/apps/nineminicompany/getCompanyHiddenCheckRecordItemResultList', // 查看巡查记录明细和巡查项数的界面

  // 九小场所-监督检查-巡查记录
  getNineMiniCheckManRecordList:
    '/apps/nineminicompany/getNineMiniCheckManRecordList', // 获取列表

  getAdminCheckManHiddenCheckRecordList:
    '/apps/nineminicompany/getAdminCheckManHiddenCheckRecordList', // 点击操作列的“查看巡检记录”和检查次数
  getCheckManHiddenCheckRecordItemResultList:
    '/apps/nineminicompany/getCheckManHiddenCheckRecordItemResultList', // 查看巡查记录明细和巡查项数的界面
  // 九小场所-监督检查-隐患清单
  getAdminNineMiniCheckManHiddenList:
    '/apps/nineminicompany/getAdminNineMiniCheckManHiddenList', // 获取列表

  // 九小场所-检查人员账号管理
  getNineMiniCompanyCheckManList:
    '/apps/nineminicompany/getNineMiniCompanyCheckManList', // 获取列表接口
  addNineMiniCompanyCheckMan:
    '/apps/nineminicompany/addNineMiniCompanyCheckMan', // 新增
  updateNineMiniCompanyCheckMan:
    '/apps/nineminicompany/updateNineMiniCompanyCheckMan', // 修改
  deleteNineMiniCompanyCheckMan:
    '/apps/nineminicompany/deleteNineMiniCompanyCheckMan', // 删除
  resetNineMiniCompanyCheckManPassword:
    '/apps/nineminicompany/resetNineMiniCompanyCheckManPassword', // 重置密码
  openNineMiniCompanyCheckMan:
    '/apps/nineminicompany/openNineMiniCompanyCheckMan', // 开启账号
  closeNineMiniCompanyCheckMan:
    '/apps/nineminicompany/closeNineMiniCompanyCheckMan', // 关闭账号
  addCheckManCompany: '/apps/nineminicompany/addCheckManCompany', // 新增账号-选择公司
  deleteCheckManCompany: '/apps/nineminicompany/deleteCheckManCompany', // 批量删除

  getCityDepartmentTreeList: '/apps/common/getCityDepartmentTreeList', // 市级行业部门列表
  getAreaDepartmentTreeList: '/apps/common/getAreaDepartmentTreeList', // 区县级行业部门列表
  getTownList1: '/apps/common/getTownList', // 获取乡镇列表
  getVillageList1: '/apps/common/getVillageList', // 获取村列表
  getSafetyDepartmentTreeList: '/apps/common/getSafetyDepartmentTreeList', // 获取安办
  checkLoginName: '/apps/nineminicompany/checkLoginName', // 检查登录名是否重复

  // 九小场所-四项规范
  getFourList: '/apps/nineminicompany/getFourList', // 获取列表

  // 九小场所-场所基本信息
  getNineMiniCompanyList: '/apps/nineminicompany/getNineMiniCompanyList', // 场所列表
  getNineMiniCompanyInfo: '/apps/nineminicompany/getInfo', // 获取场所信息
  updateNineMiniCompanyBaseInfo: '/apps/nineminicompany/updateBaseInfo', // 修改场所信息
  resetNineMiniCompanyPassword: '/apps/nineminicompany/resetPassword', // 重置密码
  handleCompanyProductionStatus:
    '/apps/nineminicompany/handleCompanyProductionStatus', // 关闭/开启账号
  deleteNineMiniCompany: '/apps/nineminicompany/deleteNineMiniCompany', // 删除账号
  deletePasswordCache: '/apps/nineminicompany/deletePasswordCache', // 解除锁定
  getNineMiniIndustry: '/apps/dictionary/getNineMiniIndustry', // 获取九小场所类型
  updateUsername: '/apps/nineminicompany/updateUsername', // 修改登录名
  getLinkNineMiniCompanyList: '/apps/nineminicompany/getLinkNineMiniCompanyList', // 关联场所-获取列表

  // 九小场所-日常检查清单维护
  getCheckTableList: '/apps/nineminicompany/getCheckTableList',
  addOrUpdateCheckTable: '/apps/nineminicompany/addOrUpdateCheckTable',
  deleteCheckTable: '/apps/nineminicompany/deleteCheckTable',
  getNineMiniPlaceType: '/apps/dictionary/getNineMiniPlaceType', // 编辑界面-对应监管分类数据接口
  getCheckTableItemList: '/apps/nineminicompany/getCheckTableItemList', // 检查项维护-查询
  addOrUpdateCheckTableItem: '/apps/nineminicompany/addOrUpdateCheckTableItem', // 检查项维护-新增/编辑
  deleteCheckTableItem: '/apps/nineminicompany/deleteCheckTableItem', // 检查项维护-删除
  deleteCheckTableItemByBatch:
    '/apps/nineminicompany/deleteCheckTableItemByBatch', // 检查项维护-批量删除
  getCheckManCompanyList: '/apps/nineminicompany/getCheckManCompanyList', // 获取检查人员所属公司列表
  resetNineMiniCompanyCheckManPassword: '/apps/nineminicompany/resetNineMiniCompanyCheckManPassword', // 重置密码

  // 九小场所-场所隐患库
  getAdminNineMiniHiddenList:
    '/apps/nineminicompany/getAdminNineMiniHiddenList',
  deleteAdminNineMiniHidden: '/apps/nineminicompany/deleteNineMiniHidden',

  // 统计分析-九小场所基本信息上报情况
  getNineminiCompanyRateInfoList:
    '/apps/nineminicompany/getNineminiCompanyRateInfo',
  // 统计分析-九小场所类型统计表
  getNineMiniCompanyInfoList: '/apps/nineminicompany/getNineMiniCompanyInfo',
  // 统计分析-九小场所自查隐患统计表
  getNineminiCompanyHiddenInfoList:
    '/apps/nineminicompany/getNineminiCompanyHiddenInfo',

  getCheckManHiddenAreaInfo: '/apps/nineminicompany/getCheckManHiddenAreaInfo', // 九小场所监督隐患统计表

  // 中介服务机构管理
  // 项目评价
  addOrUpdateProjectValuation:
    '/apps/facilitatingagency/addOrUpdateProjectValuation',
  // 获取当前项目的所有评价
  getProjectValuationList: '/apps/facilitatingagency/getProjectValuationList',
  // 获取年度报告的接口
  getInsuranceOrganizationYearReportList:
    '/apps/insurance/getInsuranceOrganizationYearReportList', // 获取列表

  // 绩效考核
  // 报表一
  getYearSeasonMonthList: '/apps/performance/getYearSeasonMonthList',
  getCityDepartmentList: '/apps/performance/getCityDepartmentList',
  getProcessMonthTableList: '/apps/performance/getProcessMonthTableList',
  addOrUpdateMonthTable: '/apps/performance/addOrUpdateMonthTable', // 暂存
  submitMonthTable: '/apps/performance/submitMonthTable', // 新增

  // 报表三
  getProcessMonthTableThreeList:
    '/apps/performance/getProcessMonthTableThreeList',
  addOrUpdateMonthTableThree: '/apps/performance/addOrUpdateMonthTableThree',

  // 报表二
  getProcessMonthTableTwoList: '/apps/performance/getProcessMonthTableTwoList',
  addOrUpdateMonthTableTwo: '/apps/performance/addOrUpdateMonthTableTwo', // 暂存

  // 区县
  getAreaDepartmentList: '/apps/performance/getAreaDepartmentList', // 年月日查看接口

  // 日常工作计分
  getCityWorkList: '/apps/performance/getCityWorkList',
  updateCityWork: '/apps/performance/updateCityWork',
  getAreaWorkList: '/apps/performance/getAreaWorkList',
  updateAreaWork: '/apps/performance/updateAreaWork',

  // 任务数
  // 市
  getDepartmentYearTaskList: '/apps/performance/getDepartmentYearTaskList', // 获取列表
  updateDepartmentYearTask: '/apps/performance/updateDepartmentYearTask', // 修改

  // 区
  getAreaYearTaskList: '/apps/performance/getAreaYearTaskList', // 获取列表
  updateAreaYearTask: '/apps/performance/updateAreaYearTask', // 修改

  // 绩效考核-绩效得分
  // 市直手工数据
  getDepartmentAchievementScoreList:
    '/apps/performance/getDepartmentAchievementScoreList', // 获取第二层数据

  // 区县手工数据
  getAreaAchievementScoreList: '/apps/performance/getAreaAchievementScoreList', // 获取第二层数据

  // 市直每月小结
  getCityDepartmentMonthSummaryList:
    '/apps/performance/getCityDepartmentMonthSummaryList',
  // 区县每月小结
  getAreaMonthSummaryList: '/apps/performance/getAreaMonthSummaryList',
  // 每月小结汇总
  getAchievementMonthList: '/apps/performance/getAchievementMonthList',

  // 中介管理机构
  getAgencyList: '/apps/newfacilitating/getAgencyList',
  updateAgency: '/apps/newfacilitating/updateAgency',
  getAchievementList: '/apps/newfacilitating/getAchievementList', // 业绩管理
  getAchievementDetailList:
    '/apps/newfacilitating/getAchievementDetailList', // 业绩管理-详情填报列表
  getAgencyScoreList: '/apps/newfacilitating/getAgencyScoreList', // 评分-查询
  addOrUpdateAgencyScoreList:
    '/apps/newfacilitating/addOrUpdateAgencyScoreList', // 评分-提交
  getAgencySelfAssessmentScoreList:
    '/apps/newfacilitating/getAgencySelfAssessmentScoreList', // 详情-基本信息
  getOrganizationList: '/apps/newfacilitating/getOrganizationTree', // 部门信息
  getSpecialistCertificateList: '/apps/newfacilitating/getSpecialistCertificateList', // 详情-人员信息-查看界面-证书子表
  handleFacilitatingAgencyProductionStatus: '/apps/newfacilitating/handleFacilitatingAgencyProductionStatus', // 开启、关闭账号
  deleteNewFacilitatingAgency: '/apps/newfacilitating/deleteNewFacilitatingAgency', // 删除账号
  getNewFacilitatingAgencyHandleHistoryList: '/apps/newfacilitating/getNewFacilitatingAgencyHandleHistoryList', // 获取处理记录列表
  deleteNewFacilitatingPasswordCache: '/apps/newfacilitating/deletePasswordCache', // 获取处理记录列表

  // 行政区域配置（机构端）
  getZAreaList: '/apps/dictionary/getZAreaList', // 获取全国区域列表
  addOrUpdateZArea: '/apps/dictionary/addOrUpdateZArea ', // 新增或修改
  deleteZArea: '/apps/dictionary/deleteZArea', // 删除

  // 服务机构注册公告
  getAnnounceAgencyList: '/apps/newfacilitating/getAnnounceAgencyList'

}



// WEBPACK FOOTER //
// ./src/api/api.js